/*
 * ----------------------
 *  <auto-generated>
 *      Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
 *  </auto-generated>
 * ----------------------
 */

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { Observable, of as _observableOf, throwError as _observableThrow } from 'rxjs';
import { catchError as _observableCatch, mergeMap as _observableMergeMap } from 'rxjs/operators';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IDokumentClient {
  /**
   * Ermittelt die Daten eines Dokuments anhand der übergebenen ID
   * @param id ID des Dokuments, dessen Daten ermittelt werden sollen
   * @return Das ermittelte Dokument
   */
  get(id: string): Observable<ApiDokumentResponse>;
  /**
   * Initiiert den Download eines Dokuments anhand der übergebenen ID
   * @param id ID des herunterzuladenden Dokuments
   * @return Das heruntergeladene Dokument
   */
  download(id: string): Observable<FileResponse>;
  /**
   * Initiiert den Download mehrerer Dokumente als ZIP-Archiv anhand der übergebenen IDs
   * @param dokumentIds IDs der herunterzuladenden Dokumente
   * @return Das heruntergeladene ZIP-Archiv
   */
  downloadZip(dokumentIds: string[]): Observable<FileResponse>;
  /**
     * Durchsucht den Dokumentenbestand anhand der übergebenen Suchkriterien für den aktuell aktiven Benutzer
    und gibt die gefundenen Dokumente sowie weitere Daten zur Suche zurück
     * @param apiDokumentsuche Kriterien des Suchvorgangs
     * @param start (optional) Index des Dokumentendatensatzes, ab dem Metadaten zurückgegeben werden sollen (Paging)
     * @param anzahl (optional) Anzahl der zurückzugebenden Dokumentendatensätze (Paging, Default: 10)
     * @return Die ermittelten Dokumentendaten
     */
  search(
    apiDokumentsuche: ApiDokumentsuche,
    start: number | null | undefined,
    anzahl: number | null | undefined
  ): Observable<ApiDokumentsuchergebnis>;
  /**
     * Ermittelt eine Liste von Dokumenten anhand der übergebenen Suchkriterien
    und gibt deren übergeordnete Gruppierungsebenen zurück
     * @param apiDokumentsuche Kriterien des Suchvorgangs
     * @return Die ermittelten Gruppierungsebenen
     */
  searchGroups(apiDokumentsuche: ApiDokumentsuche): Observable<ApiDokumentgruppierungsergebnis[]>;
  /**
   * Speichert die übergebenen ApiDokumentRequest-Objekte als neue oder geänderte Einträge
   * @param apiDokumente Die zu speichernden ApiDokumentRequest-Objekte
   * @return Das HTTP-Response-Objekt mit Informationen zum Ergebnis des Requests
   */
  post(apiDokumente: ApiDokumentRequest[]): Observable<ApiDokumentResponse[]>;
}

@Injectable()
export class DokumentClient implements IDokumentClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt die Daten eines Dokuments anhand der übergebenen ID
   * @param id ID des Dokuments, dessen Daten ermittelt werden sollen
   * @return Das ermittelte Dokument
   */
  get(id: string): Observable<ApiDokumentResponse> {
    let url_ = this.baseUrl + '/Dokument/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiDokumentResponse>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiDokumentResponse>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiDokumentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApiDokumentResponse.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Initiiert den Download eines Dokuments anhand der übergebenen ID
   * @param id ID des herunterzuladenden Dokuments
   * @return Das heruntergeladene Dokument
   */
  download(id: string): Observable<FileResponse> {
    let url_ = this.baseUrl + '/Dokument/{id}/download';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownload(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownload(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<FileResponse>;
            }
          } else return (_observableThrow(response_) as any) as Observable<FileResponse>;
        })
      );
  }

  protected processDownload(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Initiiert den Download mehrerer Dokumente als ZIP-Archiv anhand der übergebenen IDs
   * @param dokumentIds IDs der herunterzuladenden Dokumente
   * @return Das heruntergeladene ZIP-Archiv
   */
  downloadZip(dokumentIds: string[]): Observable<FileResponse> {
    let url_ = this.baseUrl + '/Dokument/download';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dokumentIds);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDownloadZip(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDownloadZip(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<FileResponse>;
            }
          } else return (_observableThrow(response_) as any) as Observable<FileResponse>;
        })
      );
  }

  protected processDownloadZip(response: HttpResponseBase): Observable<FileResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers.get('content-disposition')
        : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[3] || fileNameMatch[2]
          : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition
          ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
          : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return _observableOf({
        fileName: fileName,
        data: responseBlob as any,
        status: status,
        headers: _headers,
      });
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = ProblemDetails.fromJS(resultData500);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result500
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Durchsucht den Dokumentenbestand anhand der übergebenen Suchkriterien für den aktuell aktiven Benutzer
    und gibt die gefundenen Dokumente sowie weitere Daten zur Suche zurück
     * @param apiDokumentsuche Kriterien des Suchvorgangs
     * @param start (optional) Index des Dokumentendatensatzes, ab dem Metadaten zurückgegeben werden sollen (Paging)
     * @param anzahl (optional) Anzahl der zurückzugebenden Dokumentendatensätze (Paging, Default: 10)
     * @return Die ermittelten Dokumentendaten
     */
  search(
    apiDokumentsuche: ApiDokumentsuche,
    start: number | null | undefined,
    anzahl: number | null | undefined
  ): Observable<ApiDokumentsuchergebnis> {
    let url_ = this.baseUrl + '/Dokument/suche?';
    if (start !== undefined && start !== null)
      url_ += 'start=' + encodeURIComponent('' + start) + '&';
    if (anzahl !== undefined && anzahl !== null)
      url_ += 'anzahl=' + encodeURIComponent('' + anzahl) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(apiDokumentsuche);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiDokumentsuchergebnis>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiDokumentsuchergebnis>;
        })
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<ApiDokumentsuchergebnis> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApiDokumentsuchergebnis.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Ermittelt eine Liste von Dokumenten anhand der übergebenen Suchkriterien
    und gibt deren übergeordnete Gruppierungsebenen zurück
     * @param apiDokumentsuche Kriterien des Suchvorgangs
     * @return Die ermittelten Gruppierungsebenen
     */
  searchGroups(apiDokumentsuche: ApiDokumentsuche): Observable<ApiDokumentgruppierungsergebnis[]> {
    let url_ = this.baseUrl + '/Dokument/suche/gruppierung';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(apiDokumentsuche);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearchGroups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearchGroups(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiDokumentgruppierungsergebnis[]>;
            }
          } else
            return (_observableThrow(response_) as any) as Observable<
              ApiDokumentgruppierungsergebnis[]
            >;
        })
      );
  }

  protected processSearchGroups(
    response: HttpResponseBase
  ): Observable<ApiDokumentgruppierungsergebnis[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ApiDokumentgruppierungsergebnis.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Speichert die übergebenen ApiDokumentRequest-Objekte als neue oder geänderte Einträge
   * @param apiDokumente Die zu speichernden ApiDokumentRequest-Objekte
   * @return Das HTTP-Response-Objekt mit Informationen zum Ergebnis des Requests
   */
  post(apiDokumente: ApiDokumentRequest[]): Observable<ApiDokumentResponse[]> {
    let url_ = this.baseUrl + '/Dokument';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(apiDokumente);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPost(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiDokumentResponse[]>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiDokumentResponse[]>;
        })
      );
  }

  protected processPost(response: HttpResponseBase): Observable<ApiDokumentResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiDokumentResponse.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IDokumenteigenschaftClient {
  /**
   * Ermittelt alle Dokumenteigenschaften.
   * @return Alle Dokumenteigenschaften.
   */
  get(): Observable<ApiDokumenteigenschaft[]>;
}

@Injectable()
export class DokumenteigenschaftClient implements IDokumenteigenschaftClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt alle Dokumenteigenschaften.
   * @return Alle Dokumenteigenschaften.
   */
  get(): Observable<ApiDokumenteigenschaft[]> {
    let url_ = this.baseUrl + '/Dokumenteigenschaft';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiDokumenteigenschaft[]>;
            }
          } else
            return (_observableThrow(response_) as any) as Observable<ApiDokumenteigenschaft[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiDokumenteigenschaft[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiDokumenteigenschaft.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IFilterClient {
  /**
   * Ermittelt alle Filter
   * @return Die ermittelten Filter
   */
  get(): Observable<ApiFilter[]>;
}

@Injectable()
export class FilterClient implements IFilterClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt alle Filter
   * @return Die ermittelten Filter
   */
  get(): Observable<ApiFilter[]> {
    let url_ = this.baseUrl + '/Filter';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFilter[]>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFilter[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiFilter[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiFilter.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IFiltergruppeClient {
  /**
   * Ermittelt alle Filtergruppen des aktiven Benutzers
   * @return Die ermittelten Filtergruppen
   */
  getAll(): Observable<ApiFiltergruppe[]>;
  /**
     * Fügt dem Datenbestand die Kopfdaten einer neuen Filtergruppe für den aktiven Benutzer hinzu.
    Für das Hinzufügen von Filtern zur Gruppe existiert ein eigener Endpunkt
     * @param filtergruppe Die hinzuzufügende Filtergruppe
     * @return Die hinzugefügte Filtergruppe
     */
  add(filtergruppe: ApiFiltergruppe): Observable<ApiFiltergruppe>;
  /**
   * Ermittelt die Filtergruppe des aktiven Benutzers anhand der übergebenen ID
   * @param id ID der zu ermittelnden Filtergruppe
   * @return Die ermittelten Filtergruppen
   */
  get(id: string): Observable<ApiFiltergruppe>;
  /**
   * Speichert die übergebenen Filterwerte an der durch die ID identifizierten Filtergruppe
   * @param id ID der Filtergruppe, deren Filterwerte gespeichert werden sollen
   * @param werte Die zu speichernden Filterwerte
   * @return Die gespeicherten Filterwerte
   */
  saveFiltergruppenwerte(
    id: string,
    werte: ApiFiltergruppenwerte
  ): Observable<ApiFiltergruppenwerte>;
  /**
   * Ermittelt die Filter der anhand der übergebenen ID identifizierten Filtergruppe des aktiven Benutzers
   * @param id ID der Filtergruppe, deren Filter ermittelt werden sollen
   * @return Die ermittelten Filter
   */
  getFilter(id: string): Observable<ApiFiltergruppenfilter[]>;
  /**
   * Ermittelt die anzuzeigenden Dokumenteigenschaften der anhand der übergebenen ID identifizierten Filtergruppe des aktiven Benutzers
   * @param id ID der Filtergruppe, deren anzuzeigenden Dokumenteigenschaften ermittelt werden sollen
   * @return Die ermittelten Dokumenteigenschaften
   */
  getDokumenteigenschaften(id: string): Observable<ApiFiltergruppendokumenteigenschaft[]>;
  /**
   * Teilt eine Filtergruppe mit anderen Benutzern
   * @param id ID der zu teilenden Filtergruppe
   * @param emailadressen Liste der Mailadressen der Benutzer, mit denen die Filtergruppe geteilt werden soll
   * @return HTTP-Status der Anforderung
   */
  share(id: string, emailadressen: string[]): Observable<void>;
  /**
   * Kopiert eine Filtergruppe und legt die Kopie unter einem neuen Namen für den aktuellen Benutzer an
   * @param id ID der zu teilenden Filtergruppe
   * @param name (optional) Name für die neu anzulegende Filtergruppe
   * @return Die durch die Kopie neu angelegte Filtergruppe
   */
  copy(id: string, name: string | null | undefined): Observable<ApiFiltergruppe>;
}

@Injectable()
export class FiltergruppeClient implements IFiltergruppeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt alle Filtergruppen des aktiven Benutzers
   * @return Die ermittelten Filtergruppen
   */
  getAll(): Observable<ApiFiltergruppe[]> {
    let url_ = this.baseUrl + '/Filtergruppe';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetAll(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppe[]>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFiltergruppe[]>;
        })
      );
  }

  protected processGetAll(response: HttpResponseBase): Observable<ApiFiltergruppe[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiFiltergruppe.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
     * Fügt dem Datenbestand die Kopfdaten einer neuen Filtergruppe für den aktiven Benutzer hinzu.
    Für das Hinzufügen von Filtern zur Gruppe existiert ein eigener Endpunkt
     * @param filtergruppe Die hinzuzufügende Filtergruppe
     * @return Die hinzugefügte Filtergruppe
     */
  add(filtergruppe: ApiFiltergruppe): Observable<ApiFiltergruppe> {
    let url_ = this.baseUrl + '/Filtergruppe';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filtergruppe);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAdd(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAdd(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppe>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFiltergruppe>;
        })
      );
  }

  protected processAdd(response: HttpResponseBase): Observable<ApiFiltergruppe> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 201) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result201: any = null;
          let resultData201 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result201 = ApiFiltergruppe.fromJS(resultData201);
          return _observableOf(result201);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Ermittelt die Filtergruppe des aktiven Benutzers anhand der übergebenen ID
   * @param id ID der zu ermittelnden Filtergruppe
   * @return Die ermittelten Filtergruppen
   */
  get(id: string): Observable<ApiFiltergruppe> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppe>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFiltergruppe>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiFiltergruppe> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApiFiltergruppe.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Speichert die übergebenen Filterwerte an der durch die ID identifizierten Filtergruppe
   * @param id ID der Filtergruppe, deren Filterwerte gespeichert werden sollen
   * @param werte Die zu speichernden Filterwerte
   * @return Die gespeicherten Filterwerte
   */
  saveFiltergruppenwerte(
    id: string,
    werte: ApiFiltergruppenwerte
  ): Observable<ApiFiltergruppenwerte> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(werte);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSaveFiltergruppenwerte(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSaveFiltergruppenwerte(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppenwerte>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFiltergruppenwerte>;
        })
      );
  }

  protected processSaveFiltergruppenwerte(
    response: HttpResponseBase
  ): Observable<ApiFiltergruppenwerte> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApiFiltergruppenwerte.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException('A server side error occurred.', status, _responseText, _headers);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Ermittelt die Filter der anhand der übergebenen ID identifizierten Filtergruppe des aktiven Benutzers
   * @param id ID der Filtergruppe, deren Filter ermittelt werden sollen
   * @return Die ermittelten Filter
   */
  getFilter(id: string): Observable<ApiFiltergruppenfilter[]> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}/filter';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFilter(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetFilter(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppenfilter[]>;
            }
          } else
            return (_observableThrow(response_) as any) as Observable<ApiFiltergruppenfilter[]>;
        })
      );
  }

  protected processGetFilter(response: HttpResponseBase): Observable<ApiFiltergruppenfilter[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiFiltergruppenfilter.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Ermittelt die anzuzeigenden Dokumenteigenschaften der anhand der übergebenen ID identifizierten Filtergruppe des aktiven Benutzers
   * @param id ID der Filtergruppe, deren anzuzeigenden Dokumenteigenschaften ermittelt werden sollen
   * @return Die ermittelten Dokumenteigenschaften
   */
  getDokumenteigenschaften(id: string): Observable<ApiFiltergruppendokumenteigenschaft[]> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}/dokumenteigenschaften';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDokumenteigenschaften(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDokumenteigenschaften(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<
                ApiFiltergruppendokumenteigenschaft[]
              >;
            }
          } else
            return (_observableThrow(response_) as any) as Observable<
              ApiFiltergruppendokumenteigenschaft[]
            >;
        })
      );
  }

  protected processGetDokumenteigenschaften(
    response: HttpResponseBase
  ): Observable<ApiFiltergruppendokumenteigenschaft[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ApiFiltergruppendokumenteigenschaft.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Teilt eine Filtergruppe mit anderen Benutzern
   * @param id ID der zu teilenden Filtergruppe
   * @param emailadressen Liste der Mailadressen der Benutzer, mit denen die Filtergruppe geteilt werden soll
   * @return HTTP-Status der Anforderung
   */
  share(id: string, emailadressen: string[]): Observable<void> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}/teilen';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(emailadressen);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processShare(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processShare(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<void>;
            }
          } else return (_observableThrow(response_) as any) as Observable<void>;
        })
      );
  }

  protected processShare(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return _observableOf(null as any);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }

  /**
   * Kopiert eine Filtergruppe und legt die Kopie unter einem neuen Namen für den aktuellen Benutzer an
   * @param id ID der zu teilenden Filtergruppe
   * @param name (optional) Name für die neu anzulegende Filtergruppe
   * @return Die durch die Kopie neu angelegte Filtergruppe
   */
  copy(id: string, name: string | null | undefined): Observable<ApiFiltergruppe> {
    let url_ = this.baseUrl + '/Filtergruppe/{id}/kopieren?';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (name !== undefined && name !== null) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCopy(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCopy(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiFiltergruppe>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiFiltergruppe>;
        })
      );
  }

  protected processCopy(response: HttpResponseBase): Observable<ApiFiltergruppe> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApiFiltergruppe.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = resultData404 !== undefined ? resultData404 : <any>null;

          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result404
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IKfmaoCodeClient {
  /**
   * Ermittelt alle KfmaoCodes
   * @return Die ermittelten KfmaoCode
   */
  get(): Observable<ApiKfmaoCode[]>;
}

@Injectable()
export class KfmaoCodeClient implements IKfmaoCodeClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt alle KfmaoCodes
   * @return Die ermittelten KfmaoCode
   */
  get(): Observable<ApiKfmaoCode[]> {
    let url_ = this.baseUrl + '/KfmaoCode';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiKfmaoCode[]>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiKfmaoCode[]>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<ApiKfmaoCode[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiKfmaoCode.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface IStandortClient {
  /**
   * Ermittelt eine Liste von Standorten zum übergebenen Suchtext mit einer Mindestlänge von  Zeichen
   * @param s (optional) Suchtext zur Ermittlung der Standorte
   * @return Liste der ermittelten Standorte
   */
  search(s: string | null | undefined): Observable<ApiStandort[]>;
}

@Injectable()
export class StandortClient implements IStandortClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt eine Liste von Standorten zum übergebenen Suchtext mit einer Mindestlänge von  Zeichen
   * @param s (optional) Suchtext zur Ermittlung der Standorte
   * @return Liste der ermittelten Standorte
   */
  search(s: string | null | undefined): Observable<ApiStandort[]> {
    let url_ = this.baseUrl + '/Standort/suche?';
    if (s !== undefined && s !== null) url_ += 's=' + encodeURIComponent('' + s) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<ApiStandort[]>;
            }
          } else return (_observableThrow(response_) as any) as Observable<ApiStandort[]>;
        })
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<ApiStandort[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ApiStandort.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = ProblemDetails.fromJS(resultData400);
          return throwException(
            'A server side error occurred.',
            status,
            _responseText,
            _headers,
            result400
          );
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

export interface ITestClient {
  /**
   * Ermittelt die Daten eines Dokuments anhand der übergebenen ID
   * @return Erfolgsmeldung
   */
  get(): Observable<string>;
}

@Injectable()
export class TestClient implements ITestClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Ermittelt die Daten eines Dokuments anhand der übergebenen ID
   * @return Erfolgsmeldung
   */
  get(): Observable<string> {
    let url_ = this.baseUrl + '/Test';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGet(response_ as any);
            } catch (e) {
              return (_observableThrow(e) as any) as Observable<string>;
            }
          } else return (_observableThrow(response_) as any) as Observable<string>;
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText: string) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf(null as any);
  }
}

/** Metadaten eines Dokuments für Responses von der API an aufrufende Clients */
export class ApiDokumentResponse implements IApiDokumentResponse {
  /** Abteilung / Ausschuß / Fachbereich SAP-Name: ABTEILUNG */
  abteilungAusschussFachbereich?: string | undefined;
  /** Anfragenummer SAP-Name: ANFNR */
  anfragenummer?: string | undefined;
  /** Angebotsnummer SAP-Name: ANGNR */
  angebotsnummer?: string | undefined;
  /** Anker SAP-Name: ANKER */
  anker?: string | undefined;
  /** ArchivID SAP-Name: ARC_DOC_ID */
  archivId!: string;
  /** Archivierungsdauer SAP-Name: ARCHIVIERUNGSDAUER */
  archivierungsdauer?: number | undefined;
  /** Auftragsbezeichung SAP-Name: AUFTEXT */
  auftragsbezeichung?: string | undefined;
  /** Auftragsnummer Extern SAP-Name: AUFNR_EXT */
  auftragsnummerExtern?: string | undefined;
  /** Auftragsnummer Intern SAP-Name: AUFNR_INT */
  auftragsnummerIntern?: string | undefined;
  /** Barcode SAP-Name: BARCODE */
  barcode?: string | undefined;
  /** Beschreibung Dokument SAP-Name: DOC_DESCR */
  beschreibungDokument?: string | undefined;
  /** Bestellanforderungsnummer SAP-Name: BANFN */
  bestellanforderungsnummer?: string | undefined;
  /** Bestellnummer SAP-Name: EBELN */
  bestellnummer?: string | undefined;
  /** Bez des Lieferanten SAP-Name: BEZ_LIEFERANT */
  bezeichnungDesLieferanten?: string | undefined;
  /** Buchungskreis SAP-Name: BUKRS */
  buchungskreis?: string | undefined;
  /** Budgetart SAP-Name: BUDGETART */
  budgetart?: string | undefined;
  /** BW-Index SAP-Name: BI_NR */
  bwIndex?: string | undefined;
  /** CO-Belegnummer SAP-Name: CO_BELNR */
  coBelegnummer?: string | undefined;
  /** Content Repository SAP-Name: CONTREP_ID */
  repository!: string;
  /** Dateiname SAP-Name: FILENAME */
  dateiname?: string | undefined;
  /** Datum Endfaktura SAP-Name: ENDFAKTURADAT */
  datumEndfaktura?: Date | undefined;
  /** DIN 276 / Kostengruppe 1 SAP-Name: KSTGRP1 */
  din276Kostengruppe1?: string | undefined;
  /** DIN 276 / Kostengruppe 2 SAP-Name: KSTGRP2 */
  din276Kostengruppe2?: string | undefined;
  /** DIN 276 / Kostengruppe 3 SAP-Name: KSTGRP3 */
  din276Kostengruppe3?: string | undefined;
  /** DIN 276 / Kostengruppe 4 SAP-Name: KSTGRP4 */
  din276Kostengruppe4?: string | undefined;
  /** DIN 276 / Kostengruppe 5 SAP-Name: KSTGRP5 */
  din276Kostengruppe5?: string | undefined;
  /** Dokumentart aus Sendesystem SAP-Name: DOKAR_SND */
  dokumentartSendesystem?: string | undefined;
  /** Dokumenten ID aus Sendesystem SAP-Name: DOCNUMBER_SND */
  dokumentenIdSendesystem?: string | undefined;
  /** DokumentenID SAP-Name: DOCNUMBER */
  dokumentenId?: string | undefined;
  /** Dokumentenversion SAP-Name: */
  dokumentenversion?: string | undefined;
  /** Dokumenttitel SAP-Name: DOC_TITLE */
  dokumenttitel?: string | undefined;
  /** Dokumentversion aus Sendesystem SAP-Name: DOCVERSION_SND */
  dokumentversionSendesystem?: string | undefined;
  /** Eingangsrechnungsnummer SAP-Name: RE_BELNR */
  eingangsrechnungsnummer?: string | undefined;
  /** Equipmentbezeichnung SAP-Name: EQUTXT */
  equipmentbezeichnung?: string | undefined;
  /** Equipmentnummer SAP-Name: EQUNR */
  equipmentnummer?: string | undefined;
  /** Erfassungsdatum SAP-Name: CRDAT */
  erfassungsdatum?: Date | undefined;
  /** Erledigungsdatum SAP-Name: ERLDT */
  erledigungsdatum?: Date | undefined;
  /** Erstelldatum des Dokuments SAP-Name: ERDAT */
  erstelldatum?: Date | undefined;
  /** Ersteller SAP-Name: ERNAM */
  ersteller?: string | undefined;
  /** Fakturanummer SAP-Name: VBELN_VF */
  fakturanummer?: string | undefined;
  /** FI-Belegnummer SAP-Name: BELNR_D */
  fiBelegnummer?: string | undefined;
  /** forcont/DeTeImmobilien: Korrespondenznummer SAP-Name: FORCONT_KORRES */
  forcontDTIKorrespondenznummer?: string | undefined;
  /** forcont/DeTeImmobilien: Niederlassung SAP-Name: FORCONT_NIEDERL */
  forcontDTINiederlassung?: string | undefined;
  /** Freitext SAP-Name: FREITEXT */
  freitext?: string | undefined;
  /** GEFMA 198 Ebene 1 Nr. SAP-Name: GEFMA1 */
  gefma198Ebene1Nr?: string | undefined;
  /** Genehmiger SAP-Name: GENEHMIGER */
  genehmiger?: string | undefined;
  /** Geprüft SAP-Name: GEPRUEFT */
  geprueft!: boolean;
  /** Gesamtwert aus Dokument SAP-Name: SUMME */
  gesamtwertAusDokument?: number | undefined;
  /** Geschäftsjahr SAP-Name: GJAHR */
  geschaeftsjahr?: number | undefined;
  /** Geschoss (Text) SAP-Name: GESCHOSS_TXT */
  geschossText?: string | undefined;
  /** Geschoss (Zahl) SAP-Name: GESCHOSS */
  geschossZahl?: string | undefined;
  /** Gültig bis SAP-Name: VALID_TO */
  gueltigBis?: Date | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4?: string | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1Backup?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2Backup?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3Backup?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4Backup?: string | undefined;
  /** Kreditorennummer SAP-Name: LIFNR */
  kreditorennummer?: string | undefined;
  /** Mandant (ISS/PASM/GSUS) SAP-Name: MANDANT */
  mandant!: string;
  /** Master Debitorennummer SAP-Name: KUNNR */
  masterDebitorennummer?: string | undefined;
  /** Meldungsnummer SAP-Name: QMNUM */
  meldungsnummer?: string | undefined;
  /** MIME SAP-Name: WSAPPL */
  mime?: string | undefined;
  /** Ort SAP-Name: CITY1 */
  ort?: string | undefined;
  /** Planen und Bauen CAD-Version SAP-Name: CAD_VERSION */
  planenUndBauenCADVersion?: string | undefined;
  /** Planungsstufe SAP-Name: PLANUNGSSTUFE */
  planungsstufe?: string | undefined;
  /** PLZ SAP-Name: PSTLZ */
  plz?: string | undefined;
  /** Positionsnummer Anfrage SAP-Name: ANFPS */
  positionsnummerAnfrage?: number | undefined;
  /** Positionsnummer Angebot SAP-Name: ANGPS */
  positionsnummerAngebot?: number | undefined;
  /** Positionsnummer Bestellung SAP-Name: EBELP */
  positionsnummerBestellung?: number | undefined;
  /** Positionsnummer Eingangsechnung SAP-Name: BUZEI */
  positionsnummerEingangsrechnung?: number | undefined;
  /** Positionsnummer Faktura SAP-Name: POSNR_VF */
  positionsnummerFaktura?: number | undefined;
  /** Positionsnummer Vertrag SAP-Name: */
  positionsnummerVertrag?: number | undefined;
  /** Produktnummer SAP-Name: MATNR */
  produktnummer?: string | undefined;
  /** Projektnummer Extern SAP-Name: POSID */
  projektnummerExtern?: string | undefined;
  /** Projektnummer Intern SAP-Name: PSPIDINT */
  projektnummerIntern?: string | undefined;
  /** Prozesstyp SAP-Name: GUPROZESS */
  prozesstyp?: string | undefined;
  /** Prüfdatum SAP-Name: PRUEFDATUM */
  pruefdatum?: Date | undefined;
  /** Prüfergebnis SAP-Name: PRUEFERGEBNIS */
  pruefergebnis?: string | undefined;
  /** Rahmenvertragsnummer SAP-Name: EVRTN */
  rahmenvertragsnummer?: string | undefined;
  /** Reinigung Losart SAP-Name: LOSART */
  reinigungLosart?: string | undefined;
  /** Rückmeldetermin als Ausf.ZPt SAP-Name: RMTERMIN */
  rueckmeldeZeitpunkt?: Date | undefined;
  /** SAPDokart SAP-Name: DOKAR */
  sapDokArt?: string | undefined;
  /** SAPDokclass SAP-Name: DOC_CLASS */
  sapDokClass?: string | undefined;
  /** SAPDokpart SAP-Name: DOCPART */
  sapDokPart?: string | undefined;
  /** SAPDokvers SAP-Name: DOCVERSION */
  sapDokVers?: string | undefined;
  /** Straße SAP-Name: STREET */
  strasse?: string | undefined;
  /** Teildokument aus Sendesystem SAP-Name: DOCPART_SND */
  teildokumentSendesystem?: string | undefined;
  /** Thema SAP-Name: THEMA */
  thema?: string | undefined;
  /** Ticketnummer Extern SAP-Name: TICKETNR_EXT */
  ticketnummerExtern?: string | undefined;
  /** Ticketnummer Intern SAP-Name: TICKETNR_INT */
  ticketnummerIntern?: string | undefined;
  /** Ticketnummer REM SAP-Name: DOKNR_SND */
  ticketnummerRem?: string | undefined;
  /** TP-Grundstück (GSUS Sicht) SAP-Name: TP_AD_GR */
  gsusTpGr?: string | undefined;
  /** TP-Gebäude (GSUS Sicht) SAP-Name: TP_GE */
  gsusTpGe?: string | undefined;
  /** TP / IMDAS SAP-Name: TPLNR */
  tpimdas?: string | undefined;
  /** Übermittlungstyp SAP-Name: GUTRANS */
  uebermittlungstyp?: string | undefined;
  /** Verantwortlicher MA beim Dienstleister SAP-Name: VERANTW_MA */
  verantwortlicherMaDienstleister?: string | undefined;
  /** Verkaufsbelegnummer SAP-Name: VBELN */
  verkaufsbelegnummer?: string | undefined;
  /** Veröffentlichungsjahr SAP-Name: VJAHR */
  veroeffentlichungsjahr?: number | undefined;
  /** Vertragsbeginn SAP-Name: RECNBEG */
  vertragsbeginn?: Date | undefined;
  /** Vertragsende SAP-Name: RECNEND */
  vertragsende?: Date | undefined;
  /** Vertragsnummer SAP-Name: RECNNR */
  vertragsnummer?: string | undefined;
  /** Vertragspartner SAP-Name: V_PARTNER */
  vertragspartner?: string | undefined;
  /** VPSZ SAP-Name: VPSZ */
  vpsz?: string | undefined;
  /** Währunggschlüssel SAP-Name: WAERS */
  waehrunggschluessel?: string | undefined;
  /** Wartungspaket SAP-Name: WARTUNGSPAKET */
  wartungspaket?: string | undefined;
  /** WE Nummer SAP-Name: SWENR */
  weNummer?: string | undefined;
  /** Wegfalldatum SAP-Name: DEL_DATE */
  wegfalldatum?: Date | undefined;
  /** Typ des Dokuments */
  dokumenttyp!: ApiDokumenttyp;
  /** Gibt an, ob das Dokument gelöscht ist */
  geloescht!: boolean;
  /** Eindeutige ID der Dokument-Metadaten für die externe Verwendung */
  id!: string;

  constructor(data?: IApiDokumentResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.dokumenttyp = new ApiDokumenttyp();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.abteilungAusschussFachbereich = _data['abteilungAusschussFachbereich'];
      this.anfragenummer = _data['anfragenummer'];
      this.angebotsnummer = _data['angebotsnummer'];
      this.anker = _data['anker'];
      this.archivId = _data['archivId'];
      this.archivierungsdauer = _data['archivierungsdauer'];
      this.auftragsbezeichung = _data['auftragsbezeichung'];
      this.auftragsnummerExtern = _data['auftragsnummerExtern'];
      this.auftragsnummerIntern = _data['auftragsnummerIntern'];
      this.barcode = _data['barcode'];
      this.beschreibungDokument = _data['beschreibungDokument'];
      this.bestellanforderungsnummer = _data['bestellanforderungsnummer'];
      this.bestellnummer = _data['bestellnummer'];
      this.bezeichnungDesLieferanten = _data['bezeichnungDesLieferanten'];
      this.buchungskreis = _data['buchungskreis'];
      this.budgetart = _data['budgetart'];
      this.bwIndex = _data['bwIndex'];
      this.coBelegnummer = _data['coBelegnummer'];
      this.repository = _data['repository'];
      this.dateiname = _data['dateiname'];
      this.datumEndfaktura = _data['datumEndfaktura']
        ? new Date(_data['datumEndfaktura'].toString())
        : <any>undefined;
      this.din276Kostengruppe1 = _data['din276Kostengruppe1'];
      this.din276Kostengruppe2 = _data['din276Kostengruppe2'];
      this.din276Kostengruppe3 = _data['din276Kostengruppe3'];
      this.din276Kostengruppe4 = _data['din276Kostengruppe4'];
      this.din276Kostengruppe5 = _data['din276Kostengruppe5'];
      this.dokumentartSendesystem = _data['dokumentartSendesystem'];
      this.dokumentenIdSendesystem = _data['dokumentenIdSendesystem'];
      this.dokumentenId = _data['dokumentenId'];
      this.dokumentenversion = _data['dokumentenversion'];
      this.dokumenttitel = _data['dokumenttitel'];
      this.dokumentversionSendesystem = _data['dokumentversionSendesystem'];
      this.eingangsrechnungsnummer = _data['eingangsrechnungsnummer'];
      this.equipmentbezeichnung = _data['equipmentbezeichnung'];
      this.equipmentnummer = _data['equipmentnummer'];
      this.erfassungsdatum = _data['erfassungsdatum']
        ? new Date(_data['erfassungsdatum'].toString())
        : <any>undefined;
      this.erledigungsdatum = _data['erledigungsdatum']
        ? new Date(_data['erledigungsdatum'].toString())
        : <any>undefined;
      this.erstelldatum = _data['erstelldatum']
        ? new Date(_data['erstelldatum'].toString())
        : <any>undefined;
      this.ersteller = _data['ersteller'];
      this.fakturanummer = _data['fakturanummer'];
      this.fiBelegnummer = _data['fiBelegnummer'];
      this.forcontDTIKorrespondenznummer = _data['forcontDTIKorrespondenznummer'];
      this.forcontDTINiederlassung = _data['forcontDTINiederlassung'];
      this.freitext = _data['freitext'];
      this.gefma198Ebene1Nr = _data['gefma198Ebene1Nr'];
      this.genehmiger = _data['genehmiger'];
      this.geprueft = _data['geprueft'];
      this.gesamtwertAusDokument = _data['gesamtwertAusDokument'];
      this.geschaeftsjahr = _data['geschaeftsjahr'];
      this.geschossText = _data['geschossText'];
      this.geschossZahl = _data['geschossZahl'];
      this.gueltigBis = _data['gueltigBis']
        ? new Date(_data['gueltigBis'].toString())
        : <any>undefined;
      this.kfmaoCode1 = _data['kfmaoCode1'];
      this.kfmaoCode2 = _data['kfmaoCode2'];
      this.kfmaoCode3 = _data['kfmaoCode3'];
      this.kfmaoCode4 = _data['kfmaoCode4'];
      this.kfmaoCode1Backup = _data['kfmaoCode1Backup'];
      this.kfmaoCode2Backup = _data['kfmaoCode2Backup'];
      this.kfmaoCode3Backup = _data['kfmaoCode3Backup'];
      this.kfmaoCode4Backup = _data['kfmaoCode4Backup'];
      this.kreditorennummer = _data['kreditorennummer'];
      this.mandant = _data['mandant'];
      this.masterDebitorennummer = _data['masterDebitorennummer'];
      this.meldungsnummer = _data['meldungsnummer'];
      this.mime = _data['mime'];
      this.ort = _data['ort'];
      this.planenUndBauenCADVersion = _data['planenUndBauenCADVersion'];
      this.planungsstufe = _data['planungsstufe'];
      this.plz = _data['plz'];
      this.positionsnummerAnfrage = _data['positionsnummerAnfrage'];
      this.positionsnummerAngebot = _data['positionsnummerAngebot'];
      this.positionsnummerBestellung = _data['positionsnummerBestellung'];
      this.positionsnummerEingangsrechnung = _data['positionsnummerEingangsrechnung'];
      this.positionsnummerFaktura = _data['positionsnummerFaktura'];
      this.positionsnummerVertrag = _data['positionsnummerVertrag'];
      this.produktnummer = _data['produktnummer'];
      this.projektnummerExtern = _data['projektnummerExtern'];
      this.projektnummerIntern = _data['projektnummerIntern'];
      this.prozesstyp = _data['prozesstyp'];
      this.pruefdatum = _data['pruefdatum']
        ? new Date(_data['pruefdatum'].toString())
        : <any>undefined;
      this.pruefergebnis = _data['pruefergebnis'];
      this.rahmenvertragsnummer = _data['rahmenvertragsnummer'];
      this.reinigungLosart = _data['reinigungLosart'];
      this.rueckmeldeZeitpunkt = _data['rueckmeldeZeitpunkt']
        ? new Date(_data['rueckmeldeZeitpunkt'].toString())
        : <any>undefined;
      this.sapDokArt = _data['sapDokArt'];
      this.sapDokClass = _data['sapDokClass'];
      this.sapDokPart = _data['sapDokPart'];
      this.sapDokVers = _data['sapDokVers'];
      this.strasse = _data['strasse'];
      this.teildokumentSendesystem = _data['teildokumentSendesystem'];
      this.thema = _data['thema'];
      this.ticketnummerExtern = _data['ticketnummerExtern'];
      this.ticketnummerIntern = _data['ticketnummerIntern'];
      this.ticketnummerRem = _data['ticketnummerRem'];
      this.gsusTpGr = _data['gsusTpGr'];
      this.gsusTpGe = _data['gsusTpGe'];
      this.tpimdas = _data['tpimdas'];
      this.uebermittlungstyp = _data['uebermittlungstyp'];
      this.verantwortlicherMaDienstleister = _data['verantwortlicherMaDienstleister'];
      this.verkaufsbelegnummer = _data['verkaufsbelegnummer'];
      this.veroeffentlichungsjahr = _data['veroeffentlichungsjahr'];
      this.vertragsbeginn = _data['vertragsbeginn']
        ? new Date(_data['vertragsbeginn'].toString())
        : <any>undefined;
      this.vertragsende = _data['vertragsende']
        ? new Date(_data['vertragsende'].toString())
        : <any>undefined;
      this.vertragsnummer = _data['vertragsnummer'];
      this.vertragspartner = _data['vertragspartner'];
      this.vpsz = _data['vpsz'];
      this.waehrunggschluessel = _data['waehrunggschluessel'];
      this.wartungspaket = _data['wartungspaket'];
      this.weNummer = _data['weNummer'];
      this.wegfalldatum = _data['wegfalldatum']
        ? new Date(_data['wegfalldatum'].toString())
        : <any>undefined;
      this.dokumenttyp = _data['dokumenttyp']
        ? ApiDokumenttyp.fromJS(_data['dokumenttyp'])
        : new ApiDokumenttyp();
      this.geloescht = _data['geloescht'];
      this.id = _data['id'];
    }
  }

  static fromJS(data: any): ApiDokumentResponse {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['abteilungAusschussFachbereich'] = this.abteilungAusschussFachbereich;
    data['anfragenummer'] = this.anfragenummer;
    data['angebotsnummer'] = this.angebotsnummer;
    data['anker'] = this.anker;
    data['archivId'] = this.archivId;
    data['archivierungsdauer'] = this.archivierungsdauer;
    data['auftragsbezeichung'] = this.auftragsbezeichung;
    data['auftragsnummerExtern'] = this.auftragsnummerExtern;
    data['auftragsnummerIntern'] = this.auftragsnummerIntern;
    data['barcode'] = this.barcode;
    data['beschreibungDokument'] = this.beschreibungDokument;
    data['bestellanforderungsnummer'] = this.bestellanforderungsnummer;
    data['bestellnummer'] = this.bestellnummer;
    data['bezeichnungDesLieferanten'] = this.bezeichnungDesLieferanten;
    data['buchungskreis'] = this.buchungskreis;
    data['budgetart'] = this.budgetart;
    data['bwIndex'] = this.bwIndex;
    data['coBelegnummer'] = this.coBelegnummer;
    data['repository'] = this.repository;
    data['dateiname'] = this.dateiname;
    data['datumEndfaktura'] = this.datumEndfaktura
      ? this.datumEndfaktura.toISOString()
      : <any>undefined;
    data['din276Kostengruppe1'] = this.din276Kostengruppe1;
    data['din276Kostengruppe2'] = this.din276Kostengruppe2;
    data['din276Kostengruppe3'] = this.din276Kostengruppe3;
    data['din276Kostengruppe4'] = this.din276Kostengruppe4;
    data['din276Kostengruppe5'] = this.din276Kostengruppe5;
    data['dokumentartSendesystem'] = this.dokumentartSendesystem;
    data['dokumentenIdSendesystem'] = this.dokumentenIdSendesystem;
    data['dokumentenId'] = this.dokumentenId;
    data['dokumentenversion'] = this.dokumentenversion;
    data['dokumenttitel'] = this.dokumenttitel;
    data['dokumentversionSendesystem'] = this.dokumentversionSendesystem;
    data['eingangsrechnungsnummer'] = this.eingangsrechnungsnummer;
    data['equipmentbezeichnung'] = this.equipmentbezeichnung;
    data['equipmentnummer'] = this.equipmentnummer;
    data['erfassungsdatum'] = this.erfassungsdatum
      ? this.erfassungsdatum.toISOString()
      : <any>undefined;
    data['erledigungsdatum'] = this.erledigungsdatum
      ? this.erledigungsdatum.toISOString()
      : <any>undefined;
    data['erstelldatum'] = this.erstelldatum ? this.erstelldatum.toISOString() : <any>undefined;
    data['ersteller'] = this.ersteller;
    data['fakturanummer'] = this.fakturanummer;
    data['fiBelegnummer'] = this.fiBelegnummer;
    data['forcontDTIKorrespondenznummer'] = this.forcontDTIKorrespondenznummer;
    data['forcontDTINiederlassung'] = this.forcontDTINiederlassung;
    data['freitext'] = this.freitext;
    data['gefma198Ebene1Nr'] = this.gefma198Ebene1Nr;
    data['genehmiger'] = this.genehmiger;
    data['geprueft'] = this.geprueft;
    data['gesamtwertAusDokument'] = this.gesamtwertAusDokument;
    data['geschaeftsjahr'] = this.geschaeftsjahr;
    data['geschossText'] = this.geschossText;
    data['geschossZahl'] = this.geschossZahl;
    data['gueltigBis'] = this.gueltigBis ? this.gueltigBis.toISOString() : <any>undefined;
    data['kfmaoCode1'] = this.kfmaoCode1;
    data['kfmaoCode2'] = this.kfmaoCode2;
    data['kfmaoCode3'] = this.kfmaoCode3;
    data['kfmaoCode4'] = this.kfmaoCode4;
    data['kfmaoCode1Backup'] = this.kfmaoCode1Backup;
    data['kfmaoCode2Backup'] = this.kfmaoCode2Backup;
    data['kfmaoCode3Backup'] = this.kfmaoCode3Backup;
    data['kfmaoCode4Backup'] = this.kfmaoCode4Backup;
    data['kreditorennummer'] = this.kreditorennummer;
    data['mandant'] = this.mandant;
    data['masterDebitorennummer'] = this.masterDebitorennummer;
    data['meldungsnummer'] = this.meldungsnummer;
    data['mime'] = this.mime;
    data['ort'] = this.ort;
    data['planenUndBauenCADVersion'] = this.planenUndBauenCADVersion;
    data['planungsstufe'] = this.planungsstufe;
    data['plz'] = this.plz;
    data['positionsnummerAnfrage'] = this.positionsnummerAnfrage;
    data['positionsnummerAngebot'] = this.positionsnummerAngebot;
    data['positionsnummerBestellung'] = this.positionsnummerBestellung;
    data['positionsnummerEingangsrechnung'] = this.positionsnummerEingangsrechnung;
    data['positionsnummerFaktura'] = this.positionsnummerFaktura;
    data['positionsnummerVertrag'] = this.positionsnummerVertrag;
    data['produktnummer'] = this.produktnummer;
    data['projektnummerExtern'] = this.projektnummerExtern;
    data['projektnummerIntern'] = this.projektnummerIntern;
    data['prozesstyp'] = this.prozesstyp;
    data['pruefdatum'] = this.pruefdatum ? this.pruefdatum.toISOString() : <any>undefined;
    data['pruefergebnis'] = this.pruefergebnis;
    data['rahmenvertragsnummer'] = this.rahmenvertragsnummer;
    data['reinigungLosart'] = this.reinigungLosart;
    data['rueckmeldeZeitpunkt'] = this.rueckmeldeZeitpunkt
      ? this.rueckmeldeZeitpunkt.toISOString()
      : <any>undefined;
    data['sapDokArt'] = this.sapDokArt;
    data['sapDokClass'] = this.sapDokClass;
    data['sapDokPart'] = this.sapDokPart;
    data['sapDokVers'] = this.sapDokVers;
    data['strasse'] = this.strasse;
    data['teildokumentSendesystem'] = this.teildokumentSendesystem;
    data['thema'] = this.thema;
    data['ticketnummerExtern'] = this.ticketnummerExtern;
    data['ticketnummerIntern'] = this.ticketnummerIntern;
    data['ticketnummerRem'] = this.ticketnummerRem;
    data['gsusTpGr'] = this.gsusTpGr;
    data['gsusTpGe'] = this.gsusTpGe;
    data['tpimdas'] = this.tpimdas;
    data['uebermittlungstyp'] = this.uebermittlungstyp;
    data['verantwortlicherMaDienstleister'] = this.verantwortlicherMaDienstleister;
    data['verkaufsbelegnummer'] = this.verkaufsbelegnummer;
    data['veroeffentlichungsjahr'] = this.veroeffentlichungsjahr;
    data['vertragsbeginn'] = this.vertragsbeginn
      ? this.vertragsbeginn.toISOString()
      : <any>undefined;
    data['vertragsende'] = this.vertragsende ? this.vertragsende.toISOString() : <any>undefined;
    data['vertragsnummer'] = this.vertragsnummer;
    data['vertragspartner'] = this.vertragspartner;
    data['vpsz'] = this.vpsz;
    data['waehrunggschluessel'] = this.waehrunggschluessel;
    data['wartungspaket'] = this.wartungspaket;
    data['weNummer'] = this.weNummer;
    data['wegfalldatum'] = this.wegfalldatum ? this.wegfalldatum.toISOString() : <any>undefined;
    data['dokumenttyp'] = this.dokumenttyp ? this.dokumenttyp.toJSON() : <any>undefined;
    data['geloescht'] = this.geloescht;
    data['id'] = this.id;
    return data;
  }
}

/** Metadaten eines Dokuments für Responses von der API an aufrufende Clients */
export interface IApiDokumentResponse {
  /** Abteilung / Ausschuß / Fachbereich SAP-Name: ABTEILUNG */
  abteilungAusschussFachbereich?: string | undefined;
  /** Anfragenummer SAP-Name: ANFNR */
  anfragenummer?: string | undefined;
  /** Angebotsnummer SAP-Name: ANGNR */
  angebotsnummer?: string | undefined;
  /** Anker SAP-Name: ANKER */
  anker?: string | undefined;
  /** ArchivID SAP-Name: ARC_DOC_ID */
  archivId: string;
  /** Archivierungsdauer SAP-Name: ARCHIVIERUNGSDAUER */
  archivierungsdauer?: number | undefined;
  /** Auftragsbezeichung SAP-Name: AUFTEXT */
  auftragsbezeichung?: string | undefined;
  /** Auftragsnummer Extern SAP-Name: AUFNR_EXT */
  auftragsnummerExtern?: string | undefined;
  /** Auftragsnummer Intern SAP-Name: AUFNR_INT */
  auftragsnummerIntern?: string | undefined;
  /** Barcode SAP-Name: BARCODE */
  barcode?: string | undefined;
  /** Beschreibung Dokument SAP-Name: DOC_DESCR */
  beschreibungDokument?: string | undefined;
  /** Bestellanforderungsnummer SAP-Name: BANFN */
  bestellanforderungsnummer?: string | undefined;
  /** Bestellnummer SAP-Name: EBELN */
  bestellnummer?: string | undefined;
  /** Bez des Lieferanten SAP-Name: BEZ_LIEFERANT */
  bezeichnungDesLieferanten?: string | undefined;
  /** Buchungskreis SAP-Name: BUKRS */
  buchungskreis?: string | undefined;
  /** Budgetart SAP-Name: BUDGETART */
  budgetart?: string | undefined;
  /** BW-Index SAP-Name: BI_NR */
  bwIndex?: string | undefined;
  /** CO-Belegnummer SAP-Name: CO_BELNR */
  coBelegnummer?: string | undefined;
  /** Content Repository SAP-Name: CONTREP_ID */
  repository: string;
  /** Dateiname SAP-Name: FILENAME */
  dateiname?: string | undefined;
  /** Datum Endfaktura SAP-Name: ENDFAKTURADAT */
  datumEndfaktura?: Date | undefined;
  /** DIN 276 / Kostengruppe 1 SAP-Name: KSTGRP1 */
  din276Kostengruppe1?: string | undefined;
  /** DIN 276 / Kostengruppe 2 SAP-Name: KSTGRP2 */
  din276Kostengruppe2?: string | undefined;
  /** DIN 276 / Kostengruppe 3 SAP-Name: KSTGRP3 */
  din276Kostengruppe3?: string | undefined;
  /** DIN 276 / Kostengruppe 4 SAP-Name: KSTGRP4 */
  din276Kostengruppe4?: string | undefined;
  /** DIN 276 / Kostengruppe 5 SAP-Name: KSTGRP5 */
  din276Kostengruppe5?: string | undefined;
  /** Dokumentart aus Sendesystem SAP-Name: DOKAR_SND */
  dokumentartSendesystem?: string | undefined;
  /** Dokumenten ID aus Sendesystem SAP-Name: DOCNUMBER_SND */
  dokumentenIdSendesystem?: string | undefined;
  /** DokumentenID SAP-Name: DOCNUMBER */
  dokumentenId?: string | undefined;
  /** Dokumentenversion SAP-Name: */
  dokumentenversion?: string | undefined;
  /** Dokumenttitel SAP-Name: DOC_TITLE */
  dokumenttitel?: string | undefined;
  /** Dokumentversion aus Sendesystem SAP-Name: DOCVERSION_SND */
  dokumentversionSendesystem?: string | undefined;
  /** Eingangsrechnungsnummer SAP-Name: RE_BELNR */
  eingangsrechnungsnummer?: string | undefined;
  /** Equipmentbezeichnung SAP-Name: EQUTXT */
  equipmentbezeichnung?: string | undefined;
  /** Equipmentnummer SAP-Name: EQUNR */
  equipmentnummer?: string | undefined;
  /** Erfassungsdatum SAP-Name: CRDAT */
  erfassungsdatum?: Date | undefined;
  /** Erledigungsdatum SAP-Name: ERLDT */
  erledigungsdatum?: Date | undefined;
  /** Erstelldatum des Dokuments SAP-Name: ERDAT */
  erstelldatum?: Date | undefined;
  /** Ersteller SAP-Name: ERNAM */
  ersteller?: string | undefined;
  /** Fakturanummer SAP-Name: VBELN_VF */
  fakturanummer?: string | undefined;
  /** FI-Belegnummer SAP-Name: BELNR_D */
  fiBelegnummer?: string | undefined;
  /** forcont/DeTeImmobilien: Korrespondenznummer SAP-Name: FORCONT_KORRES */
  forcontDTIKorrespondenznummer?: string | undefined;
  /** forcont/DeTeImmobilien: Niederlassung SAP-Name: FORCONT_NIEDERL */
  forcontDTINiederlassung?: string | undefined;
  /** Freitext SAP-Name: FREITEXT */
  freitext?: string | undefined;
  /** GEFMA 198 Ebene 1 Nr. SAP-Name: GEFMA1 */
  gefma198Ebene1Nr?: string | undefined;
  /** Genehmiger SAP-Name: GENEHMIGER */
  genehmiger?: string | undefined;
  /** Geprüft SAP-Name: GEPRUEFT */
  geprueft: boolean;
  /** Gesamtwert aus Dokument SAP-Name: SUMME */
  gesamtwertAusDokument?: number | undefined;
  /** Geschäftsjahr SAP-Name: GJAHR */
  geschaeftsjahr?: number | undefined;
  /** Geschoss (Text) SAP-Name: GESCHOSS_TXT */
  geschossText?: string | undefined;
  /** Geschoss (Zahl) SAP-Name: GESCHOSS */
  geschossZahl?: string | undefined;
  /** Gültig bis SAP-Name: VALID_TO */
  gueltigBis?: Date | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4?: string | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1Backup?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2Backup?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3Backup?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4Backup?: string | undefined;
  /** Kreditorennummer SAP-Name: LIFNR */
  kreditorennummer?: string | undefined;
  /** Mandant (ISS/PASM/GSUS) SAP-Name: MANDANT */
  mandant: string;
  /** Master Debitorennummer SAP-Name: KUNNR */
  masterDebitorennummer?: string | undefined;
  /** Meldungsnummer SAP-Name: QMNUM */
  meldungsnummer?: string | undefined;
  /** MIME SAP-Name: WSAPPL */
  mime?: string | undefined;
  /** Ort SAP-Name: CITY1 */
  ort?: string | undefined;
  /** Planen und Bauen CAD-Version SAP-Name: CAD_VERSION */
  planenUndBauenCADVersion?: string | undefined;
  /** Planungsstufe SAP-Name: PLANUNGSSTUFE */
  planungsstufe?: string | undefined;
  /** PLZ SAP-Name: PSTLZ */
  plz?: string | undefined;
  /** Positionsnummer Anfrage SAP-Name: ANFPS */
  positionsnummerAnfrage?: number | undefined;
  /** Positionsnummer Angebot SAP-Name: ANGPS */
  positionsnummerAngebot?: number | undefined;
  /** Positionsnummer Bestellung SAP-Name: EBELP */
  positionsnummerBestellung?: number | undefined;
  /** Positionsnummer Eingangsechnung SAP-Name: BUZEI */
  positionsnummerEingangsrechnung?: number | undefined;
  /** Positionsnummer Faktura SAP-Name: POSNR_VF */
  positionsnummerFaktura?: number | undefined;
  /** Positionsnummer Vertrag SAP-Name: */
  positionsnummerVertrag?: number | undefined;
  /** Produktnummer SAP-Name: MATNR */
  produktnummer?: string | undefined;
  /** Projektnummer Extern SAP-Name: POSID */
  projektnummerExtern?: string | undefined;
  /** Projektnummer Intern SAP-Name: PSPIDINT */
  projektnummerIntern?: string | undefined;
  /** Prozesstyp SAP-Name: GUPROZESS */
  prozesstyp?: string | undefined;
  /** Prüfdatum SAP-Name: PRUEFDATUM */
  pruefdatum?: Date | undefined;
  /** Prüfergebnis SAP-Name: PRUEFERGEBNIS */
  pruefergebnis?: string | undefined;
  /** Rahmenvertragsnummer SAP-Name: EVRTN */
  rahmenvertragsnummer?: string | undefined;
  /** Reinigung Losart SAP-Name: LOSART */
  reinigungLosart?: string | undefined;
  /** Rückmeldetermin als Ausf.ZPt SAP-Name: RMTERMIN */
  rueckmeldeZeitpunkt?: Date | undefined;
  /** SAPDokart SAP-Name: DOKAR */
  sapDokArt?: string | undefined;
  /** SAPDokclass SAP-Name: DOC_CLASS */
  sapDokClass?: string | undefined;
  /** SAPDokpart SAP-Name: DOCPART */
  sapDokPart?: string | undefined;
  /** SAPDokvers SAP-Name: DOCVERSION */
  sapDokVers?: string | undefined;
  /** Straße SAP-Name: STREET */
  strasse?: string | undefined;
  /** Teildokument aus Sendesystem SAP-Name: DOCPART_SND */
  teildokumentSendesystem?: string | undefined;
  /** Thema SAP-Name: THEMA */
  thema?: string | undefined;
  /** Ticketnummer Extern SAP-Name: TICKETNR_EXT */
  ticketnummerExtern?: string | undefined;
  /** Ticketnummer Intern SAP-Name: TICKETNR_INT */
  ticketnummerIntern?: string | undefined;
  /** Ticketnummer REM SAP-Name: DOKNR_SND */
  ticketnummerRem?: string | undefined;
  /** TP-Grundstück (GSUS Sicht) SAP-Name: TP_AD_GR */
  gsusTpGr?: string | undefined;
  /** TP-Gebäude (GSUS Sicht) SAP-Name: TP_GE */
  gsusTpGe?: string | undefined;
  /** TP / IMDAS SAP-Name: TPLNR */
  tpimdas?: string | undefined;
  /** Übermittlungstyp SAP-Name: GUTRANS */
  uebermittlungstyp?: string | undefined;
  /** Verantwortlicher MA beim Dienstleister SAP-Name: VERANTW_MA */
  verantwortlicherMaDienstleister?: string | undefined;
  /** Verkaufsbelegnummer SAP-Name: VBELN */
  verkaufsbelegnummer?: string | undefined;
  /** Veröffentlichungsjahr SAP-Name: VJAHR */
  veroeffentlichungsjahr?: number | undefined;
  /** Vertragsbeginn SAP-Name: RECNBEG */
  vertragsbeginn?: Date | undefined;
  /** Vertragsende SAP-Name: RECNEND */
  vertragsende?: Date | undefined;
  /** Vertragsnummer SAP-Name: RECNNR */
  vertragsnummer?: string | undefined;
  /** Vertragspartner SAP-Name: V_PARTNER */
  vertragspartner?: string | undefined;
  /** VPSZ SAP-Name: VPSZ */
  vpsz?: string | undefined;
  /** Währunggschlüssel SAP-Name: WAERS */
  waehrunggschluessel?: string | undefined;
  /** Wartungspaket SAP-Name: WARTUNGSPAKET */
  wartungspaket?: string | undefined;
  /** WE Nummer SAP-Name: SWENR */
  weNummer?: string | undefined;
  /** Wegfalldatum SAP-Name: DEL_DATE */
  wegfalldatum?: Date | undefined;
  /** Typ des Dokuments */
  dokumenttyp: ApiDokumenttyp;
  /** Gibt an, ob das Dokument gelöscht ist */
  geloescht: boolean;
  /** Eindeutige ID der Dokument-Metadaten für die externe Verwendung */
  id: string;
}

/** Basiseigenschaften eines Dokumenttyps */
export class ApiDokumenttyp implements IApiDokumenttyp {
  /** Das Kürzel des Dokumenttyps */
  id!: string;
  /** Der Langtext des Dokumenttyps */
  langtext?: string | undefined;

  constructor(data?: IApiDokumenttyp) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.langtext = _data['langtext'];
    }
  }

  static fromJS(data: any): ApiDokumenttyp {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumenttyp();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['langtext'] = this.langtext;
    return data;
  }
}

/** Basiseigenschaften eines Dokumenttyps */
export interface IApiDokumenttyp {
  /** Das Kürzel des Dokumenttyps */
  id: string;
  /** Der Langtext des Dokumenttyps */
  langtext?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

/** Ergebnis einer Dokumentensuche */
export class ApiDokumentsuchergebnis implements IApiDokumentsuchergebnis {
  /** Liste der gefundenen Dokumente */
  objekte!: ApiDokumentResponse[];
  /** Die Gesamtzahl aller gefundenen Dokumente ohne Berücksichtigung von Paging-Einschränkungen */
  gesamtanzahl!: number;
  /** Der Standort der gefundenen Dokumente oder null, wenn kein eindeutiger Standort vorliegt */
  standort?: ApiStandort | undefined;

  constructor(data?: IApiDokumentsuchergebnis) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.objekte = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['objekte'])) {
        this.objekte = [] as any;
        for (let item of _data['objekte']) this.objekte!.push(ApiDokumentResponse.fromJS(item));
      }
      this.gesamtanzahl = _data['gesamtanzahl'];
      this.standort = _data['standort'] ? ApiStandort.fromJS(_data['standort']) : <any>undefined;
    }
  }

  static fromJS(data: any): ApiDokumentsuchergebnis {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentsuchergebnis();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.objekte)) {
      data['objekte'] = [];
      for (let item of this.objekte) data['objekte'].push(item.toJSON());
    }
    data['gesamtanzahl'] = this.gesamtanzahl;
    data['standort'] = this.standort ? this.standort.toJSON() : <any>undefined;
    return data;
  }
}

/** Ergebnis einer Dokumentensuche */
export interface IApiDokumentsuchergebnis {
  /** Liste der gefundenen Dokumente */
  objekte: ApiDokumentResponse[];
  /** Die Gesamtzahl aller gefundenen Dokumente ohne Berücksichtigung von Paging-Einschränkungen */
  gesamtanzahl: number;
  /** Der Standort der gefundenen Dokumente oder null, wenn kein eindeutiger Standort vorliegt */
  standort?: ApiStandort | undefined;
}

/** Standort (Wirtschaftseinheit) */
export class ApiStandort implements IApiStandort {
  /** Eindeutige ID des Standorts für die externe Verwendung */
  id!: string;
  /** Nummer des Standorts */
  gsusNummer!: string;
  /** TP6- oder TP8-Nummer des Standortes */
  technischerPlatz!: string;
  /** WE-Nummer des Standortes */
  wirtschaftseinheit!: string;
  /** Die Strasse des Standortes */
  strasse?: string | undefined;
  /** Die Postleitzahl des Standortes */
  plz?: string | undefined;
  /** Der Ort des Standortes */
  ort?: string | undefined;
  /** Technische Objektbezeichnung des Standortes */
  objektbezeichnung?: string | undefined;

  constructor(data?: IApiStandort) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.gsusNummer = _data['gsusNummer'];
      this.technischerPlatz = _data['technischerPlatz'];
      this.wirtschaftseinheit = _data['wirtschaftseinheit'];
      this.strasse = _data['strasse'];
      this.plz = _data['plz'];
      this.ort = _data['ort'];
      this.objektbezeichnung = _data['objektbezeichnung'];
    }
  }

  static fromJS(data: any): ApiStandort {
    data = typeof data === 'object' ? data : {};
    let result = new ApiStandort();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['gsusNummer'] = this.gsusNummer;
    data['technischerPlatz'] = this.technischerPlatz;
    data['wirtschaftseinheit'] = this.wirtschaftseinheit;
    data['strasse'] = this.strasse;
    data['plz'] = this.plz;
    data['ort'] = this.ort;
    data['objektbezeichnung'] = this.objektbezeichnung;
    return data;
  }
}

/** Standort (Wirtschaftseinheit) */
export interface IApiStandort {
  /** Eindeutige ID des Standorts für die externe Verwendung */
  id: string;
  /** Nummer des Standorts */
  gsusNummer: string;
  /** TP6- oder TP8-Nummer des Standortes */
  technischerPlatz: string;
  /** WE-Nummer des Standortes */
  wirtschaftseinheit: string;
  /** Die Strasse des Standortes */
  strasse?: string | undefined;
  /** Die Postleitzahl des Standortes */
  plz?: string | undefined;
  /** Der Ort des Standortes */
  ort?: string | undefined;
  /** Technische Objektbezeichnung des Standortes */
  objektbezeichnung?: string | undefined;
}

/** Enthält Suchparameter für eine Suche nach Dokumentmetadaten */
export class ApiDokumentsuche implements IApiDokumentsuche {
  /** ID der Filtergruppe, für die Dokumentensuche ausgeführt werden soll */
  filtergruppeId!: string;
  /** Nummer der Wirtschaftseinheit (WE), deren Dokumente gesucht werden sollen */
  wirtschaftseinheit?: string | undefined;
  /** Gliederungsnummer, deren Dokumente gesucht werden sollen */
  gliederungsnummer?: string | undefined;
  /** Liste von Sortieroptionen */
  sortierungen!: Sortierung[];
  /** Liste der anzuwendenden Filter */
  filter!: ApiDokumentsuchfilter[];

  constructor(data?: IApiDokumentsuche) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.sortierungen = [];
      this.filter = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filtergruppeId = _data['filtergruppeId'];
      this.wirtschaftseinheit = _data['wirtschaftseinheit'];
      this.gliederungsnummer = _data['gliederungsnummer'];
      if (Array.isArray(_data['sortierungen'])) {
        this.sortierungen = [] as any;
        for (let item of _data['sortierungen']) this.sortierungen!.push(Sortierung.fromJS(item));
      }
      if (Array.isArray(_data['filter'])) {
        this.filter = [] as any;
        for (let item of _data['filter']) this.filter!.push(ApiDokumentsuchfilter.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApiDokumentsuche {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentsuche();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['filtergruppeId'] = this.filtergruppeId;
    data['wirtschaftseinheit'] = this.wirtschaftseinheit;
    data['gliederungsnummer'] = this.gliederungsnummer;
    if (Array.isArray(this.sortierungen)) {
      data['sortierungen'] = [];
      for (let item of this.sortierungen) data['sortierungen'].push(item.toJSON());
    }
    if (Array.isArray(this.filter)) {
      data['filter'] = [];
      for (let item of this.filter) data['filter'].push(item.toJSON());
    }
    return data;
  }
}

/** Enthält Suchparameter für eine Suche nach Dokumentmetadaten */
export interface IApiDokumentsuche {
  /** ID der Filtergruppe, für die Dokumentensuche ausgeführt werden soll */
  filtergruppeId: string;
  /** Nummer der Wirtschaftseinheit (WE), deren Dokumente gesucht werden sollen */
  wirtschaftseinheit?: string | undefined;
  /** Gliederungsnummer, deren Dokumente gesucht werden sollen */
  gliederungsnummer?: string | undefined;
  /** Liste von Sortieroptionen */
  sortierungen: Sortierung[];
  /** Liste der anzuwendenden Filter */
  filter: ApiDokumentsuchfilter[];
}

/** Optionen für die Sortierung von Datensätzen */
export class Sortierung implements ISortierung {
  /** Name des Feldes, nachdem sortiert werden soll */
  sortierfeld!: string;
  /** Gibt die Reihenfolgt der Sortierung an */
  sortierrichtung!: Sortierrichtung;

  constructor(data?: ISortierung) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sortierfeld = _data['sortierfeld'];
      this.sortierrichtung = _data['sortierrichtung'];
    }
  }

  static fromJS(data: any): Sortierung {
    data = typeof data === 'object' ? data : {};
    let result = new Sortierung();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['sortierfeld'] = this.sortierfeld;
    data['sortierrichtung'] = this.sortierrichtung;
    return data;
  }
}

/** Optionen für die Sortierung von Datensätzen */
export interface ISortierung {
  /** Name des Feldes, nachdem sortiert werden soll */
  sortierfeld: string;
  /** Gibt die Reihenfolgt der Sortierung an */
  sortierrichtung: Sortierrichtung;
}

/** Aufzählungswerte für die auf- oder absteigende Sortierung von Daten */
export enum Sortierrichtung {
  KeineSortierung = 0,
  Aufsteigend = 1,
  Absteigend = -1,
}

/** Enthält die konkreten Filterdaten einer Suchanfrage */
export class ApiDokumentsuchfilter implements IApiDokumentsuchfilter {
  /** ID des Filters */
  id!: string;
  /** Der für den Filtervorgang zu verwendende Wert */
  wert?: string | undefined;

  constructor(data?: IApiDokumentsuchfilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.wert = _data['wert'];
    }
  }

  static fromJS(data: any): ApiDokumentsuchfilter {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentsuchfilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['wert'] = this.wert;
    return data;
  }
}

/** Enthält die konkreten Filterdaten einer Suchanfrage */
export interface IApiDokumentsuchfilter {
  /** ID des Filters */
  id: string;
  /** Der für den Filtervorgang zu verwendende Wert */
  wert?: string | undefined;
}

/** Ergebnis einer Suche nach Dokumentengruppierung */
export class ApiDokumentgruppierungsergebnis implements IApiDokumentgruppierungsergebnis {
  /** Ebene der Dokumentengruppierung (z.b. A.1.2) */
  gliederungsnummer?: string | undefined;
  /** Elternebene der Dokumentengruppierung */
  uebergeordneteGliederungsnummer?: string | undefined;
  /** Beschreibung der Gruppierung */
  beschreibung?: string | undefined;
  /** Anzahl der Dokumente zu dieser Gliederung */
  anzahl!: number;

  constructor(data?: IApiDokumentgruppierungsergebnis) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.gliederungsnummer = _data['gliederungsnummer'];
      this.uebergeordneteGliederungsnummer = _data['uebergeordneteGliederungsnummer'];
      this.beschreibung = _data['beschreibung'];
      this.anzahl = _data['anzahl'];
    }
  }

  static fromJS(data: any): ApiDokumentgruppierungsergebnis {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentgruppierungsergebnis();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['gliederungsnummer'] = this.gliederungsnummer;
    data['uebergeordneteGliederungsnummer'] = this.uebergeordneteGliederungsnummer;
    data['beschreibung'] = this.beschreibung;
    data['anzahl'] = this.anzahl;
    return data;
  }
}

/** Ergebnis einer Suche nach Dokumentengruppierung */
export interface IApiDokumentgruppierungsergebnis {
  /** Ebene der Dokumentengruppierung (z.b. A.1.2) */
  gliederungsnummer?: string | undefined;
  /** Elternebene der Dokumentengruppierung */
  uebergeordneteGliederungsnummer?: string | undefined;
  /** Beschreibung der Gruppierung */
  beschreibung?: string | undefined;
  /** Anzahl der Dokumente zu dieser Gliederung */
  anzahl: number;
}

/** Metadaten eines Dokuments für Requests an die API */
export class ApiDokumentRequest implements IApiDokumentRequest {
  /** Abteilung / Ausschuß / Fachbereich SAP-Name: ABTEILUNG */
  abteilungAusschussFachbereich?: string | undefined;
  /** Anfragenummer SAP-Name: ANFNR */
  anfragenummer?: string | undefined;
  /** Angebotsnummer SAP-Name: ANGNR */
  angebotsnummer?: string | undefined;
  /** Anker SAP-Name: ANKER */
  anker?: string | undefined;
  /** ArchivID SAP-Name: ARC_DOC_ID */
  archivId!: string;
  /** Archivierungsdauer SAP-Name: ARCHIVIERUNGSDAUER */
  archivierungsdauer?: number | undefined;
  /** Auftragsbezeichung SAP-Name: AUFTEXT */
  auftragsbezeichung?: string | undefined;
  /** Auftragsnummer Extern SAP-Name: AUFNR_EXT */
  auftragsnummerExtern?: string | undefined;
  /** Auftragsnummer Intern SAP-Name: AUFNR_INT */
  auftragsnummerIntern?: string | undefined;
  /** Barcode SAP-Name: BARCODE */
  barcode?: string | undefined;
  /** Beschreibung Dokument SAP-Name: DOC_DESCR */
  beschreibungDokument?: string | undefined;
  /** Bestellanforderungsnummer SAP-Name: BANFN */
  bestellanforderungsnummer?: string | undefined;
  /** Bestellnummer SAP-Name: EBELN */
  bestellnummer?: string | undefined;
  /** Bez des Lieferanten SAP-Name: BEZ_LIEFERANT */
  bezeichnungDesLieferanten?: string | undefined;
  /** Buchungskreis SAP-Name: BUKRS */
  buchungskreis?: string | undefined;
  /** Budgetart SAP-Name: BUDGETART */
  budgetart?: string | undefined;
  /** BW-Index SAP-Name: BI_NR */
  bwIndex?: string | undefined;
  /** CO-Belegnummer SAP-Name: CO_BELNR */
  coBelegnummer?: string | undefined;
  /** Content Repository SAP-Name: CONTREP_ID */
  repository!: string;
  /** Dateiname SAP-Name: FILENAME */
  dateiname?: string | undefined;
  /** Datum Endfaktura SAP-Name: ENDFAKTURADAT */
  datumEndfaktura?: Date | undefined;
  /** DIN 276 / Kostengruppe 1 SAP-Name: KSTGRP1 */
  din276Kostengruppe1?: string | undefined;
  /** DIN 276 / Kostengruppe 2 SAP-Name: KSTGRP2 */
  din276Kostengruppe2?: string | undefined;
  /** DIN 276 / Kostengruppe 3 SAP-Name: KSTGRP3 */
  din276Kostengruppe3?: string | undefined;
  /** DIN 276 / Kostengruppe 4 SAP-Name: KSTGRP4 */
  din276Kostengruppe4?: string | undefined;
  /** DIN 276 / Kostengruppe 5 SAP-Name: KSTGRP5 */
  din276Kostengruppe5?: string | undefined;
  /** Dokumentart aus Sendesystem SAP-Name: DOKAR_SND */
  dokumentartSendesystem?: string | undefined;
  /** Dokumenten ID aus Sendesystem SAP-Name: DOCNUMBER_SND */
  dokumentenIdSendesystem?: string | undefined;
  /** DokumentenID SAP-Name: DOCNUMBER */
  dokumentenId?: string | undefined;
  /** Dokumentenversion SAP-Name: */
  dokumentenversion?: string | undefined;
  /** Dokumenttitel SAP-Name: DOC_TITLE */
  dokumenttitel?: string | undefined;
  /** Dokumentversion aus Sendesystem SAP-Name: DOCVERSION_SND */
  dokumentversionSendesystem?: string | undefined;
  /** Eingangsrechnungsnummer SAP-Name: RE_BELNR */
  eingangsrechnungsnummer?: string | undefined;
  /** Equipmentbezeichnung SAP-Name: EQUTXT */
  equipmentbezeichnung?: string | undefined;
  /** Equipmentnummer SAP-Name: EQUNR */
  equipmentnummer?: string | undefined;
  /** Erfassungsdatum SAP-Name: CRDAT */
  erfassungsdatum?: Date | undefined;
  /** Erledigungsdatum SAP-Name: ERLDT */
  erledigungsdatum?: Date | undefined;
  /** Erstelldatum des Dokuments SAP-Name: ERDAT */
  erstelldatum?: Date | undefined;
  /** Ersteller SAP-Name: ERNAM */
  ersteller?: string | undefined;
  /** Fakturanummer SAP-Name: VBELN_VF */
  fakturanummer?: string | undefined;
  /** FI-Belegnummer SAP-Name: BELNR_D */
  fiBelegnummer?: string | undefined;
  /** forcont/DeTeImmobilien: Korrespondenznummer SAP-Name: FORCONT_KORRES */
  forcontDTIKorrespondenznummer?: string | undefined;
  /** forcont/DeTeImmobilien: Niederlassung SAP-Name: FORCONT_NIEDERL */
  forcontDTINiederlassung?: string | undefined;
  /** Freitext SAP-Name: FREITEXT */
  freitext?: string | undefined;
  /** GEFMA 198 Ebene 1 Nr. SAP-Name: GEFMA1 */
  gefma198Ebene1Nr?: string | undefined;
  /** Genehmiger SAP-Name: GENEHMIGER */
  genehmiger?: string | undefined;
  /** Geprüft SAP-Name: GEPRUEFT */
  geprueft!: boolean;
  /** Gesamtwert aus Dokument SAP-Name: SUMME */
  gesamtwertAusDokument?: number | undefined;
  /** Geschäftsjahr SAP-Name: GJAHR */
  geschaeftsjahr?: number | undefined;
  /** Geschoss (Text) SAP-Name: GESCHOSS_TXT */
  geschossText?: string | undefined;
  /** Geschoss (Zahl) SAP-Name: GESCHOSS */
  geschossZahl?: string | undefined;
  /** Gültig bis SAP-Name: VALID_TO */
  gueltigBis?: Date | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4?: string | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1Backup?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2Backup?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3Backup?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4Backup?: string | undefined;
  /** Kreditorennummer SAP-Name: LIFNR */
  kreditorennummer?: string | undefined;
  /** Mandant (ISS/PASM/GSUS) SAP-Name: MANDANT */
  mandant!: string;
  /** Master Debitorennummer SAP-Name: KUNNR */
  masterDebitorennummer?: string | undefined;
  /** Meldungsnummer SAP-Name: QMNUM */
  meldungsnummer?: string | undefined;
  /** MIME SAP-Name: WSAPPL */
  mime?: string | undefined;
  /** Ort SAP-Name: CITY1 */
  ort?: string | undefined;
  /** Planen und Bauen CAD-Version SAP-Name: CAD_VERSION */
  planenUndBauenCADVersion?: string | undefined;
  /** Planungsstufe SAP-Name: PLANUNGSSTUFE */
  planungsstufe?: string | undefined;
  /** PLZ SAP-Name: PSTLZ */
  plz?: string | undefined;
  /** Positionsnummer Anfrage SAP-Name: ANFPS */
  positionsnummerAnfrage?: number | undefined;
  /** Positionsnummer Angebot SAP-Name: ANGPS */
  positionsnummerAngebot?: number | undefined;
  /** Positionsnummer Bestellung SAP-Name: EBELP */
  positionsnummerBestellung?: number | undefined;
  /** Positionsnummer Eingangsechnung SAP-Name: BUZEI */
  positionsnummerEingangsrechnung?: number | undefined;
  /** Positionsnummer Faktura SAP-Name: POSNR_VF */
  positionsnummerFaktura?: number | undefined;
  /** Positionsnummer Vertrag SAP-Name: */
  positionsnummerVertrag?: number | undefined;
  /** Produktnummer SAP-Name: MATNR */
  produktnummer?: string | undefined;
  /** Projektnummer Extern SAP-Name: POSID */
  projektnummerExtern?: string | undefined;
  /** Projektnummer Intern SAP-Name: PSPIDINT */
  projektnummerIntern?: string | undefined;
  /** Prozesstyp SAP-Name: GUPROZESS */
  prozesstyp?: string | undefined;
  /** Prüfdatum SAP-Name: PRUEFDATUM */
  pruefdatum?: Date | undefined;
  /** Prüfergebnis SAP-Name: PRUEFERGEBNIS */
  pruefergebnis?: string | undefined;
  /** Rahmenvertragsnummer SAP-Name: EVRTN */
  rahmenvertragsnummer?: string | undefined;
  /** Reinigung Losart SAP-Name: LOSART */
  reinigungLosart?: string | undefined;
  /** Rückmeldetermin als Ausf.ZPt SAP-Name: RMTERMIN */
  rueckmeldeZeitpunkt?: Date | undefined;
  /** SAPDokart SAP-Name: DOKAR */
  sapDokArt?: string | undefined;
  /** SAPDokclass SAP-Name: DOC_CLASS */
  sapDokClass?: string | undefined;
  /** SAPDokpart SAP-Name: DOCPART */
  sapDokPart?: string | undefined;
  /** SAPDokvers SAP-Name: DOCVERSION */
  sapDokVers?: string | undefined;
  /** Straße SAP-Name: STREET */
  strasse?: string | undefined;
  /** Teildokument aus Sendesystem SAP-Name: DOCPART_SND */
  teildokumentSendesystem?: string | undefined;
  /** Thema SAP-Name: THEMA */
  thema?: string | undefined;
  /** Ticketnummer Extern SAP-Name: TICKETNR_EXT */
  ticketnummerExtern?: string | undefined;
  /** Ticketnummer Intern SAP-Name: TICKETNR_INT */
  ticketnummerIntern?: string | undefined;
  /** Ticketnummer REM SAP-Name: DOKNR_SND */
  ticketnummerRem?: string | undefined;
  /** TP-Grundstück (GSUS Sicht) SAP-Name: TP_AD_GR */
  gsusTpGr?: string | undefined;
  /** TP-Gebäude (GSUS Sicht) SAP-Name: TP_GE */
  gsusTpGe?: string | undefined;
  /** TP / IMDAS SAP-Name: TPLNR */
  tpimdas?: string | undefined;
  /** Übermittlungstyp SAP-Name: GUTRANS */
  uebermittlungstyp?: string | undefined;
  /** Verantwortlicher MA beim Dienstleister SAP-Name: VERANTW_MA */
  verantwortlicherMaDienstleister?: string | undefined;
  /** Verkaufsbelegnummer SAP-Name: VBELN */
  verkaufsbelegnummer?: string | undefined;
  /** Veröffentlichungsjahr SAP-Name: VJAHR */
  veroeffentlichungsjahr?: number | undefined;
  /** Vertragsbeginn SAP-Name: RECNBEG */
  vertragsbeginn?: Date | undefined;
  /** Vertragsende SAP-Name: RECNEND */
  vertragsende?: Date | undefined;
  /** Vertragsnummer SAP-Name: RECNNR */
  vertragsnummer?: string | undefined;
  /** Vertragspartner SAP-Name: V_PARTNER */
  vertragspartner?: string | undefined;
  /** VPSZ SAP-Name: VPSZ */
  vpsz?: string | undefined;
  /** Währunggschlüssel SAP-Name: WAERS */
  waehrunggschluessel?: string | undefined;
  /** Wartungspaket SAP-Name: WARTUNGSPAKET */
  wartungspaket?: string | undefined;
  /** WE Nummer SAP-Name: SWENR */
  weNummer?: string | undefined;
  /** Wegfalldatum SAP-Name: DEL_DATE */
  wegfalldatum?: Date | undefined;
  /** Typ des Dokuments */
  dokumenttyp!: ApiDokumenttyp;
  /** Gibt an, ob das Dokument gelöscht ist */
  geloescht!: boolean;

  constructor(data?: IApiDokumentRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.dokumenttyp = new ApiDokumenttyp();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.abteilungAusschussFachbereich = _data['abteilungAusschussFachbereich'];
      this.anfragenummer = _data['anfragenummer'];
      this.angebotsnummer = _data['angebotsnummer'];
      this.anker = _data['anker'];
      this.archivId = _data['archivId'];
      this.archivierungsdauer = _data['archivierungsdauer'];
      this.auftragsbezeichung = _data['auftragsbezeichung'];
      this.auftragsnummerExtern = _data['auftragsnummerExtern'];
      this.auftragsnummerIntern = _data['auftragsnummerIntern'];
      this.barcode = _data['barcode'];
      this.beschreibungDokument = _data['beschreibungDokument'];
      this.bestellanforderungsnummer = _data['bestellanforderungsnummer'];
      this.bestellnummer = _data['bestellnummer'];
      this.bezeichnungDesLieferanten = _data['bezeichnungDesLieferanten'];
      this.buchungskreis = _data['buchungskreis'];
      this.budgetart = _data['budgetart'];
      this.bwIndex = _data['bwIndex'];
      this.coBelegnummer = _data['coBelegnummer'];
      this.repository = _data['repository'];
      this.dateiname = _data['dateiname'];
      this.datumEndfaktura = _data['datumEndfaktura']
        ? new Date(_data['datumEndfaktura'].toString())
        : <any>undefined;
      this.din276Kostengruppe1 = _data['din276Kostengruppe1'];
      this.din276Kostengruppe2 = _data['din276Kostengruppe2'];
      this.din276Kostengruppe3 = _data['din276Kostengruppe3'];
      this.din276Kostengruppe4 = _data['din276Kostengruppe4'];
      this.din276Kostengruppe5 = _data['din276Kostengruppe5'];
      this.dokumentartSendesystem = _data['dokumentartSendesystem'];
      this.dokumentenIdSendesystem = _data['dokumentenIdSendesystem'];
      this.dokumentenId = _data['dokumentenId'];
      this.dokumentenversion = _data['dokumentenversion'];
      this.dokumenttitel = _data['dokumenttitel'];
      this.dokumentversionSendesystem = _data['dokumentversionSendesystem'];
      this.eingangsrechnungsnummer = _data['eingangsrechnungsnummer'];
      this.equipmentbezeichnung = _data['equipmentbezeichnung'];
      this.equipmentnummer = _data['equipmentnummer'];
      this.erfassungsdatum = _data['erfassungsdatum']
        ? new Date(_data['erfassungsdatum'].toString())
        : <any>undefined;
      this.erledigungsdatum = _data['erledigungsdatum']
        ? new Date(_data['erledigungsdatum'].toString())
        : <any>undefined;
      this.erstelldatum = _data['erstelldatum']
        ? new Date(_data['erstelldatum'].toString())
        : <any>undefined;
      this.ersteller = _data['ersteller'];
      this.fakturanummer = _data['fakturanummer'];
      this.fiBelegnummer = _data['fiBelegnummer'];
      this.forcontDTIKorrespondenznummer = _data['forcontDTIKorrespondenznummer'];
      this.forcontDTINiederlassung = _data['forcontDTINiederlassung'];
      this.freitext = _data['freitext'];
      this.gefma198Ebene1Nr = _data['gefma198Ebene1Nr'];
      this.genehmiger = _data['genehmiger'];
      this.geprueft = _data['geprueft'];
      this.gesamtwertAusDokument = _data['gesamtwertAusDokument'];
      this.geschaeftsjahr = _data['geschaeftsjahr'];
      this.geschossText = _data['geschossText'];
      this.geschossZahl = _data['geschossZahl'];
      this.gueltigBis = _data['gueltigBis']
        ? new Date(_data['gueltigBis'].toString())
        : <any>undefined;
      this.kfmaoCode1 = _data['kfmaoCode1'];
      this.kfmaoCode2 = _data['kfmaoCode2'];
      this.kfmaoCode3 = _data['kfmaoCode3'];
      this.kfmaoCode4 = _data['kfmaoCode4'];
      this.kfmaoCode1Backup = _data['kfmaoCode1Backup'];
      this.kfmaoCode2Backup = _data['kfmaoCode2Backup'];
      this.kfmaoCode3Backup = _data['kfmaoCode3Backup'];
      this.kfmaoCode4Backup = _data['kfmaoCode4Backup'];
      this.kreditorennummer = _data['kreditorennummer'];
      this.mandant = _data['mandant'];
      this.masterDebitorennummer = _data['masterDebitorennummer'];
      this.meldungsnummer = _data['meldungsnummer'];
      this.mime = _data['mime'];
      this.ort = _data['ort'];
      this.planenUndBauenCADVersion = _data['planenUndBauenCADVersion'];
      this.planungsstufe = _data['planungsstufe'];
      this.plz = _data['plz'];
      this.positionsnummerAnfrage = _data['positionsnummerAnfrage'];
      this.positionsnummerAngebot = _data['positionsnummerAngebot'];
      this.positionsnummerBestellung = _data['positionsnummerBestellung'];
      this.positionsnummerEingangsrechnung = _data['positionsnummerEingangsrechnung'];
      this.positionsnummerFaktura = _data['positionsnummerFaktura'];
      this.positionsnummerVertrag = _data['positionsnummerVertrag'];
      this.produktnummer = _data['produktnummer'];
      this.projektnummerExtern = _data['projektnummerExtern'];
      this.projektnummerIntern = _data['projektnummerIntern'];
      this.prozesstyp = _data['prozesstyp'];
      this.pruefdatum = _data['pruefdatum']
        ? new Date(_data['pruefdatum'].toString())
        : <any>undefined;
      this.pruefergebnis = _data['pruefergebnis'];
      this.rahmenvertragsnummer = _data['rahmenvertragsnummer'];
      this.reinigungLosart = _data['reinigungLosart'];
      this.rueckmeldeZeitpunkt = _data['rueckmeldeZeitpunkt']
        ? new Date(_data['rueckmeldeZeitpunkt'].toString())
        : <any>undefined;
      this.sapDokArt = _data['sapDokArt'];
      this.sapDokClass = _data['sapDokClass'];
      this.sapDokPart = _data['sapDokPart'];
      this.sapDokVers = _data['sapDokVers'];
      this.strasse = _data['strasse'];
      this.teildokumentSendesystem = _data['teildokumentSendesystem'];
      this.thema = _data['thema'];
      this.ticketnummerExtern = _data['ticketnummerExtern'];
      this.ticketnummerIntern = _data['ticketnummerIntern'];
      this.ticketnummerRem = _data['ticketnummerRem'];
      this.gsusTpGr = _data['gsusTpGr'];
      this.gsusTpGe = _data['gsusTpGe'];
      this.tpimdas = _data['tpimdas'];
      this.uebermittlungstyp = _data['uebermittlungstyp'];
      this.verantwortlicherMaDienstleister = _data['verantwortlicherMaDienstleister'];
      this.verkaufsbelegnummer = _data['verkaufsbelegnummer'];
      this.veroeffentlichungsjahr = _data['veroeffentlichungsjahr'];
      this.vertragsbeginn = _data['vertragsbeginn']
        ? new Date(_data['vertragsbeginn'].toString())
        : <any>undefined;
      this.vertragsende = _data['vertragsende']
        ? new Date(_data['vertragsende'].toString())
        : <any>undefined;
      this.vertragsnummer = _data['vertragsnummer'];
      this.vertragspartner = _data['vertragspartner'];
      this.vpsz = _data['vpsz'];
      this.waehrunggschluessel = _data['waehrunggschluessel'];
      this.wartungspaket = _data['wartungspaket'];
      this.weNummer = _data['weNummer'];
      this.wegfalldatum = _data['wegfalldatum']
        ? new Date(_data['wegfalldatum'].toString())
        : <any>undefined;
      this.dokumenttyp = _data['dokumenttyp']
        ? ApiDokumenttyp.fromJS(_data['dokumenttyp'])
        : new ApiDokumenttyp();
      this.geloescht = _data['geloescht'];
    }
  }

  static fromJS(data: any): ApiDokumentRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumentRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['abteilungAusschussFachbereich'] = this.abteilungAusschussFachbereich;
    data['anfragenummer'] = this.anfragenummer;
    data['angebotsnummer'] = this.angebotsnummer;
    data['anker'] = this.anker;
    data['archivId'] = this.archivId;
    data['archivierungsdauer'] = this.archivierungsdauer;
    data['auftragsbezeichung'] = this.auftragsbezeichung;
    data['auftragsnummerExtern'] = this.auftragsnummerExtern;
    data['auftragsnummerIntern'] = this.auftragsnummerIntern;
    data['barcode'] = this.barcode;
    data['beschreibungDokument'] = this.beschreibungDokument;
    data['bestellanforderungsnummer'] = this.bestellanforderungsnummer;
    data['bestellnummer'] = this.bestellnummer;
    data['bezeichnungDesLieferanten'] = this.bezeichnungDesLieferanten;
    data['buchungskreis'] = this.buchungskreis;
    data['budgetart'] = this.budgetart;
    data['bwIndex'] = this.bwIndex;
    data['coBelegnummer'] = this.coBelegnummer;
    data['repository'] = this.repository;
    data['dateiname'] = this.dateiname;
    data['datumEndfaktura'] = this.datumEndfaktura
      ? this.datumEndfaktura.toISOString()
      : <any>undefined;
    data['din276Kostengruppe1'] = this.din276Kostengruppe1;
    data['din276Kostengruppe2'] = this.din276Kostengruppe2;
    data['din276Kostengruppe3'] = this.din276Kostengruppe3;
    data['din276Kostengruppe4'] = this.din276Kostengruppe4;
    data['din276Kostengruppe5'] = this.din276Kostengruppe5;
    data['dokumentartSendesystem'] = this.dokumentartSendesystem;
    data['dokumentenIdSendesystem'] = this.dokumentenIdSendesystem;
    data['dokumentenId'] = this.dokumentenId;
    data['dokumentenversion'] = this.dokumentenversion;
    data['dokumenttitel'] = this.dokumenttitel;
    data['dokumentversionSendesystem'] = this.dokumentversionSendesystem;
    data['eingangsrechnungsnummer'] = this.eingangsrechnungsnummer;
    data['equipmentbezeichnung'] = this.equipmentbezeichnung;
    data['equipmentnummer'] = this.equipmentnummer;
    data['erfassungsdatum'] = this.erfassungsdatum
      ? this.erfassungsdatum.toISOString()
      : <any>undefined;
    data['erledigungsdatum'] = this.erledigungsdatum
      ? this.erledigungsdatum.toISOString()
      : <any>undefined;
    data['erstelldatum'] = this.erstelldatum ? this.erstelldatum.toISOString() : <any>undefined;
    data['ersteller'] = this.ersteller;
    data['fakturanummer'] = this.fakturanummer;
    data['fiBelegnummer'] = this.fiBelegnummer;
    data['forcontDTIKorrespondenznummer'] = this.forcontDTIKorrespondenznummer;
    data['forcontDTINiederlassung'] = this.forcontDTINiederlassung;
    data['freitext'] = this.freitext;
    data['gefma198Ebene1Nr'] = this.gefma198Ebene1Nr;
    data['genehmiger'] = this.genehmiger;
    data['geprueft'] = this.geprueft;
    data['gesamtwertAusDokument'] = this.gesamtwertAusDokument;
    data['geschaeftsjahr'] = this.geschaeftsjahr;
    data['geschossText'] = this.geschossText;
    data['geschossZahl'] = this.geschossZahl;
    data['gueltigBis'] = this.gueltigBis ? this.gueltigBis.toISOString() : <any>undefined;
    data['kfmaoCode1'] = this.kfmaoCode1;
    data['kfmaoCode2'] = this.kfmaoCode2;
    data['kfmaoCode3'] = this.kfmaoCode3;
    data['kfmaoCode4'] = this.kfmaoCode4;
    data['kfmaoCode1Backup'] = this.kfmaoCode1Backup;
    data['kfmaoCode2Backup'] = this.kfmaoCode2Backup;
    data['kfmaoCode3Backup'] = this.kfmaoCode3Backup;
    data['kfmaoCode4Backup'] = this.kfmaoCode4Backup;
    data['kreditorennummer'] = this.kreditorennummer;
    data['mandant'] = this.mandant;
    data['masterDebitorennummer'] = this.masterDebitorennummer;
    data['meldungsnummer'] = this.meldungsnummer;
    data['mime'] = this.mime;
    data['ort'] = this.ort;
    data['planenUndBauenCADVersion'] = this.planenUndBauenCADVersion;
    data['planungsstufe'] = this.planungsstufe;
    data['plz'] = this.plz;
    data['positionsnummerAnfrage'] = this.positionsnummerAnfrage;
    data['positionsnummerAngebot'] = this.positionsnummerAngebot;
    data['positionsnummerBestellung'] = this.positionsnummerBestellung;
    data['positionsnummerEingangsrechnung'] = this.positionsnummerEingangsrechnung;
    data['positionsnummerFaktura'] = this.positionsnummerFaktura;
    data['positionsnummerVertrag'] = this.positionsnummerVertrag;
    data['produktnummer'] = this.produktnummer;
    data['projektnummerExtern'] = this.projektnummerExtern;
    data['projektnummerIntern'] = this.projektnummerIntern;
    data['prozesstyp'] = this.prozesstyp;
    data['pruefdatum'] = this.pruefdatum ? this.pruefdatum.toISOString() : <any>undefined;
    data['pruefergebnis'] = this.pruefergebnis;
    data['rahmenvertragsnummer'] = this.rahmenvertragsnummer;
    data['reinigungLosart'] = this.reinigungLosart;
    data['rueckmeldeZeitpunkt'] = this.rueckmeldeZeitpunkt
      ? this.rueckmeldeZeitpunkt.toISOString()
      : <any>undefined;
    data['sapDokArt'] = this.sapDokArt;
    data['sapDokClass'] = this.sapDokClass;
    data['sapDokPart'] = this.sapDokPart;
    data['sapDokVers'] = this.sapDokVers;
    data['strasse'] = this.strasse;
    data['teildokumentSendesystem'] = this.teildokumentSendesystem;
    data['thema'] = this.thema;
    data['ticketnummerExtern'] = this.ticketnummerExtern;
    data['ticketnummerIntern'] = this.ticketnummerIntern;
    data['ticketnummerRem'] = this.ticketnummerRem;
    data['gsusTpGr'] = this.gsusTpGr;
    data['gsusTpGe'] = this.gsusTpGe;
    data['tpimdas'] = this.tpimdas;
    data['uebermittlungstyp'] = this.uebermittlungstyp;
    data['verantwortlicherMaDienstleister'] = this.verantwortlicherMaDienstleister;
    data['verkaufsbelegnummer'] = this.verkaufsbelegnummer;
    data['veroeffentlichungsjahr'] = this.veroeffentlichungsjahr;
    data['vertragsbeginn'] = this.vertragsbeginn
      ? this.vertragsbeginn.toISOString()
      : <any>undefined;
    data['vertragsende'] = this.vertragsende ? this.vertragsende.toISOString() : <any>undefined;
    data['vertragsnummer'] = this.vertragsnummer;
    data['vertragspartner'] = this.vertragspartner;
    data['vpsz'] = this.vpsz;
    data['waehrunggschluessel'] = this.waehrunggschluessel;
    data['wartungspaket'] = this.wartungspaket;
    data['weNummer'] = this.weNummer;
    data['wegfalldatum'] = this.wegfalldatum ? this.wegfalldatum.toISOString() : <any>undefined;
    data['dokumenttyp'] = this.dokumenttyp ? this.dokumenttyp.toJSON() : <any>undefined;
    data['geloescht'] = this.geloescht;
    return data;
  }
}

/** Metadaten eines Dokuments für Requests an die API */
export interface IApiDokumentRequest {
  /** Abteilung / Ausschuß / Fachbereich SAP-Name: ABTEILUNG */
  abteilungAusschussFachbereich?: string | undefined;
  /** Anfragenummer SAP-Name: ANFNR */
  anfragenummer?: string | undefined;
  /** Angebotsnummer SAP-Name: ANGNR */
  angebotsnummer?: string | undefined;
  /** Anker SAP-Name: ANKER */
  anker?: string | undefined;
  /** ArchivID SAP-Name: ARC_DOC_ID */
  archivId: string;
  /** Archivierungsdauer SAP-Name: ARCHIVIERUNGSDAUER */
  archivierungsdauer?: number | undefined;
  /** Auftragsbezeichung SAP-Name: AUFTEXT */
  auftragsbezeichung?: string | undefined;
  /** Auftragsnummer Extern SAP-Name: AUFNR_EXT */
  auftragsnummerExtern?: string | undefined;
  /** Auftragsnummer Intern SAP-Name: AUFNR_INT */
  auftragsnummerIntern?: string | undefined;
  /** Barcode SAP-Name: BARCODE */
  barcode?: string | undefined;
  /** Beschreibung Dokument SAP-Name: DOC_DESCR */
  beschreibungDokument?: string | undefined;
  /** Bestellanforderungsnummer SAP-Name: BANFN */
  bestellanforderungsnummer?: string | undefined;
  /** Bestellnummer SAP-Name: EBELN */
  bestellnummer?: string | undefined;
  /** Bez des Lieferanten SAP-Name: BEZ_LIEFERANT */
  bezeichnungDesLieferanten?: string | undefined;
  /** Buchungskreis SAP-Name: BUKRS */
  buchungskreis?: string | undefined;
  /** Budgetart SAP-Name: BUDGETART */
  budgetart?: string | undefined;
  /** BW-Index SAP-Name: BI_NR */
  bwIndex?: string | undefined;
  /** CO-Belegnummer SAP-Name: CO_BELNR */
  coBelegnummer?: string | undefined;
  /** Content Repository SAP-Name: CONTREP_ID */
  repository: string;
  /** Dateiname SAP-Name: FILENAME */
  dateiname?: string | undefined;
  /** Datum Endfaktura SAP-Name: ENDFAKTURADAT */
  datumEndfaktura?: Date | undefined;
  /** DIN 276 / Kostengruppe 1 SAP-Name: KSTGRP1 */
  din276Kostengruppe1?: string | undefined;
  /** DIN 276 / Kostengruppe 2 SAP-Name: KSTGRP2 */
  din276Kostengruppe2?: string | undefined;
  /** DIN 276 / Kostengruppe 3 SAP-Name: KSTGRP3 */
  din276Kostengruppe3?: string | undefined;
  /** DIN 276 / Kostengruppe 4 SAP-Name: KSTGRP4 */
  din276Kostengruppe4?: string | undefined;
  /** DIN 276 / Kostengruppe 5 SAP-Name: KSTGRP5 */
  din276Kostengruppe5?: string | undefined;
  /** Dokumentart aus Sendesystem SAP-Name: DOKAR_SND */
  dokumentartSendesystem?: string | undefined;
  /** Dokumenten ID aus Sendesystem SAP-Name: DOCNUMBER_SND */
  dokumentenIdSendesystem?: string | undefined;
  /** DokumentenID SAP-Name: DOCNUMBER */
  dokumentenId?: string | undefined;
  /** Dokumentenversion SAP-Name: */
  dokumentenversion?: string | undefined;
  /** Dokumenttitel SAP-Name: DOC_TITLE */
  dokumenttitel?: string | undefined;
  /** Dokumentversion aus Sendesystem SAP-Name: DOCVERSION_SND */
  dokumentversionSendesystem?: string | undefined;
  /** Eingangsrechnungsnummer SAP-Name: RE_BELNR */
  eingangsrechnungsnummer?: string | undefined;
  /** Equipmentbezeichnung SAP-Name: EQUTXT */
  equipmentbezeichnung?: string | undefined;
  /** Equipmentnummer SAP-Name: EQUNR */
  equipmentnummer?: string | undefined;
  /** Erfassungsdatum SAP-Name: CRDAT */
  erfassungsdatum?: Date | undefined;
  /** Erledigungsdatum SAP-Name: ERLDT */
  erledigungsdatum?: Date | undefined;
  /** Erstelldatum des Dokuments SAP-Name: ERDAT */
  erstelldatum?: Date | undefined;
  /** Ersteller SAP-Name: ERNAM */
  ersteller?: string | undefined;
  /** Fakturanummer SAP-Name: VBELN_VF */
  fakturanummer?: string | undefined;
  /** FI-Belegnummer SAP-Name: BELNR_D */
  fiBelegnummer?: string | undefined;
  /** forcont/DeTeImmobilien: Korrespondenznummer SAP-Name: FORCONT_KORRES */
  forcontDTIKorrespondenznummer?: string | undefined;
  /** forcont/DeTeImmobilien: Niederlassung SAP-Name: FORCONT_NIEDERL */
  forcontDTINiederlassung?: string | undefined;
  /** Freitext SAP-Name: FREITEXT */
  freitext?: string | undefined;
  /** GEFMA 198 Ebene 1 Nr. SAP-Name: GEFMA1 */
  gefma198Ebene1Nr?: string | undefined;
  /** Genehmiger SAP-Name: GENEHMIGER */
  genehmiger?: string | undefined;
  /** Geprüft SAP-Name: GEPRUEFT */
  geprueft: boolean;
  /** Gesamtwert aus Dokument SAP-Name: SUMME */
  gesamtwertAusDokument?: number | undefined;
  /** Geschäftsjahr SAP-Name: GJAHR */
  geschaeftsjahr?: number | undefined;
  /** Geschoss (Text) SAP-Name: GESCHOSS_TXT */
  geschossText?: string | undefined;
  /** Geschoss (Zahl) SAP-Name: GESCHOSS */
  geschossZahl?: string | undefined;
  /** Gültig bis SAP-Name: VALID_TO */
  gueltigBis?: Date | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4?: string | undefined;
  /** KFM AO Code1 SAP-Name: KFM_AO_CODE1 */
  kfmaoCode1Backup?: string | undefined;
  /** KFM AO Code2 SAP-Name: KFM_AO_CODE2 */
  kfmaoCode2Backup?: string | undefined;
  /** KFM AO Code3 SAP-Name: KFM_AO_CODE3 */
  kfmaoCode3Backup?: string | undefined;
  /** KFM AO Code4 SAP-Name: KFM_AO_CODE4 */
  kfmaoCode4Backup?: string | undefined;
  /** Kreditorennummer SAP-Name: LIFNR */
  kreditorennummer?: string | undefined;
  /** Mandant (ISS/PASM/GSUS) SAP-Name: MANDANT */
  mandant: string;
  /** Master Debitorennummer SAP-Name: KUNNR */
  masterDebitorennummer?: string | undefined;
  /** Meldungsnummer SAP-Name: QMNUM */
  meldungsnummer?: string | undefined;
  /** MIME SAP-Name: WSAPPL */
  mime?: string | undefined;
  /** Ort SAP-Name: CITY1 */
  ort?: string | undefined;
  /** Planen und Bauen CAD-Version SAP-Name: CAD_VERSION */
  planenUndBauenCADVersion?: string | undefined;
  /** Planungsstufe SAP-Name: PLANUNGSSTUFE */
  planungsstufe?: string | undefined;
  /** PLZ SAP-Name: PSTLZ */
  plz?: string | undefined;
  /** Positionsnummer Anfrage SAP-Name: ANFPS */
  positionsnummerAnfrage?: number | undefined;
  /** Positionsnummer Angebot SAP-Name: ANGPS */
  positionsnummerAngebot?: number | undefined;
  /** Positionsnummer Bestellung SAP-Name: EBELP */
  positionsnummerBestellung?: number | undefined;
  /** Positionsnummer Eingangsechnung SAP-Name: BUZEI */
  positionsnummerEingangsrechnung?: number | undefined;
  /** Positionsnummer Faktura SAP-Name: POSNR_VF */
  positionsnummerFaktura?: number | undefined;
  /** Positionsnummer Vertrag SAP-Name: */
  positionsnummerVertrag?: number | undefined;
  /** Produktnummer SAP-Name: MATNR */
  produktnummer?: string | undefined;
  /** Projektnummer Extern SAP-Name: POSID */
  projektnummerExtern?: string | undefined;
  /** Projektnummer Intern SAP-Name: PSPIDINT */
  projektnummerIntern?: string | undefined;
  /** Prozesstyp SAP-Name: GUPROZESS */
  prozesstyp?: string | undefined;
  /** Prüfdatum SAP-Name: PRUEFDATUM */
  pruefdatum?: Date | undefined;
  /** Prüfergebnis SAP-Name: PRUEFERGEBNIS */
  pruefergebnis?: string | undefined;
  /** Rahmenvertragsnummer SAP-Name: EVRTN */
  rahmenvertragsnummer?: string | undefined;
  /** Reinigung Losart SAP-Name: LOSART */
  reinigungLosart?: string | undefined;
  /** Rückmeldetermin als Ausf.ZPt SAP-Name: RMTERMIN */
  rueckmeldeZeitpunkt?: Date | undefined;
  /** SAPDokart SAP-Name: DOKAR */
  sapDokArt?: string | undefined;
  /** SAPDokclass SAP-Name: DOC_CLASS */
  sapDokClass?: string | undefined;
  /** SAPDokpart SAP-Name: DOCPART */
  sapDokPart?: string | undefined;
  /** SAPDokvers SAP-Name: DOCVERSION */
  sapDokVers?: string | undefined;
  /** Straße SAP-Name: STREET */
  strasse?: string | undefined;
  /** Teildokument aus Sendesystem SAP-Name: DOCPART_SND */
  teildokumentSendesystem?: string | undefined;
  /** Thema SAP-Name: THEMA */
  thema?: string | undefined;
  /** Ticketnummer Extern SAP-Name: TICKETNR_EXT */
  ticketnummerExtern?: string | undefined;
  /** Ticketnummer Intern SAP-Name: TICKETNR_INT */
  ticketnummerIntern?: string | undefined;
  /** Ticketnummer REM SAP-Name: DOKNR_SND */
  ticketnummerRem?: string | undefined;
  /** TP-Grundstück (GSUS Sicht) SAP-Name: TP_AD_GR */
  gsusTpGr?: string | undefined;
  /** TP-Gebäude (GSUS Sicht) SAP-Name: TP_GE */
  gsusTpGe?: string | undefined;
  /** TP / IMDAS SAP-Name: TPLNR */
  tpimdas?: string | undefined;
  /** Übermittlungstyp SAP-Name: GUTRANS */
  uebermittlungstyp?: string | undefined;
  /** Verantwortlicher MA beim Dienstleister SAP-Name: VERANTW_MA */
  verantwortlicherMaDienstleister?: string | undefined;
  /** Verkaufsbelegnummer SAP-Name: VBELN */
  verkaufsbelegnummer?: string | undefined;
  /** Veröffentlichungsjahr SAP-Name: VJAHR */
  veroeffentlichungsjahr?: number | undefined;
  /** Vertragsbeginn SAP-Name: RECNBEG */
  vertragsbeginn?: Date | undefined;
  /** Vertragsende SAP-Name: RECNEND */
  vertragsende?: Date | undefined;
  /** Vertragsnummer SAP-Name: RECNNR */
  vertragsnummer?: string | undefined;
  /** Vertragspartner SAP-Name: V_PARTNER */
  vertragspartner?: string | undefined;
  /** VPSZ SAP-Name: VPSZ */
  vpsz?: string | undefined;
  /** Währunggschlüssel SAP-Name: WAERS */
  waehrunggschluessel?: string | undefined;
  /** Wartungspaket SAP-Name: WARTUNGSPAKET */
  wartungspaket?: string | undefined;
  /** WE Nummer SAP-Name: SWENR */
  weNummer?: string | undefined;
  /** Wegfalldatum SAP-Name: DEL_DATE */
  wegfalldatum?: Date | undefined;
  /** Typ des Dokuments */
  dokumenttyp: ApiDokumenttyp;
  /** Gibt an, ob das Dokument gelöscht ist */
  geloescht: boolean;
}

/** Eigenschaften von Dokumenten für die API auf Basis von Dokumenteigenschaft */
export class ApiDokumenteigenschaft implements IApiDokumenteigenschaft {
  /** Eindeutige ID der Dokumenteigenschaft für die externe Verwendung */
  externalId!: string;
  /** Name/Beschreibung der Eigenschaft */
  name!: string;
  /** Name der Eigenschaft am Dokument */
  propertyName!: string;

  constructor(data?: IApiDokumenteigenschaft) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.externalId = _data['externalId'];
      this.name = _data['name'];
      this.propertyName = _data['propertyName'];
    }
  }

  static fromJS(data: any): ApiDokumenteigenschaft {
    data = typeof data === 'object' ? data : {};
    let result = new ApiDokumenteigenschaft();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['externalId'] = this.externalId;
    data['name'] = this.name;
    data['propertyName'] = this.propertyName;
    return data;
  }
}

/** Eigenschaften von Dokumenten für die API auf Basis von Dokumenteigenschaft */
export interface IApiDokumenteigenschaft {
  /** Eindeutige ID der Dokumenteigenschaft für die externe Verwendung */
  externalId: string;
  /** Name/Beschreibung der Eigenschaft */
  name: string;
  /** Name der Eigenschaft am Dokument */
  propertyName: string;
}

/** Eigenschaften eines Filters */
export class ApiFilter implements IApiFilter {
  /** Eindeutige ID des Datensatzes für die externe Verwendung */
  id!: string;
  /** Kurze Bezeichnung des Attributs zur Anzeige/Auswahl */
  name!: string;
  /** Ausführliche Beschreibung des Attributs */
  beschreibung!: string;
  /** Ein Typ, der angibt, wie das Attribut dargestellt werden soll */
  typ!: Filtertyp;
  /** Art des durchzuführenden Filtervergleichs
   */
  bedingung!: Filterbedingung;
  /** Maximale Länge im Fall von Text-Attributen */
  laenge!: number;
  /** Anzahl der Nachkommastellen bei Dezimalzahlen */
  dezimalstellen!: number;
  /** Mögliche Werte für den Filter */
  werte!: ApiFilterwert[];

  constructor(data?: IApiFilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.werte = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.beschreibung = _data['beschreibung'];
      this.typ = _data['typ'];
      this.bedingung = _data['bedingung'];
      this.laenge = _data['laenge'];
      this.dezimalstellen = _data['dezimalstellen'];
      if (Array.isArray(_data['werte'])) {
        this.werte = [] as any;
        for (let item of _data['werte']) this.werte!.push(ApiFilterwert.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApiFilter {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['beschreibung'] = this.beschreibung;
    data['typ'] = this.typ;
    data['bedingung'] = this.bedingung;
    data['laenge'] = this.laenge;
    data['dezimalstellen'] = this.dezimalstellen;
    if (Array.isArray(this.werte)) {
      data['werte'] = [];
      for (let item of this.werte) data['werte'].push(item.toJSON());
    }
    return data;
  }
}

/** Eigenschaften eines Filters */
export interface IApiFilter {
  /** Eindeutige ID des Datensatzes für die externe Verwendung */
  id: string;
  /** Kurze Bezeichnung des Attributs zur Anzeige/Auswahl */
  name: string;
  /** Ausführliche Beschreibung des Attributs */
  beschreibung: string;
  /** Ein Typ, der angibt, wie das Attribut dargestellt werden soll */
  typ: Filtertyp;
  /** Art des durchzuführenden Filtervergleichs
   */
  bedingung: Filterbedingung;
  /** Maximale Länge im Fall von Text-Attributen */
  laenge: number;
  /** Anzahl der Nachkommastellen bei Dezimalzahlen */
  dezimalstellen: number;
  /** Mögliche Werte für den Filter */
  werte: ApiFilterwert[];
}

/** Art des Filters */
export enum Filtertyp {
  Text = 0,
  Ganzzahl = 1,
  Dezimalzahl = 2,
  Auswahl = 3,
  Mehrfachauswahl = 4,
  Datum = 5,
  Zeit = 6,
  Wahrheitswert = 7,
}

/** Art des durchzuführenden Filtervergleichs */
export enum Filterbedingung {
  Equal = 0,
  GreaterThan = 1,
  GreaterThanOrEqual = 2,
  LessThan = 3,
  LessThanOrEqual = 4,
  Contains = 5,
  WildcardEqual = 6,
  StartsWith = 7,
}

/** Möglicher Wert eines Filters für Filter mit vorgegebenen Werten */
export class ApiFilterwert implements IApiFilterwert {
  /** ID des Filterwerts */
  id!: string;
  /** Text für die Anzeige/Auswahl */
  text!: string;
  /** Zusätzlicher Beschreibungstext für den Filterwert. */
  beschreibung?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Filterwerte */
  reihenfolge!: number;

  constructor(data?: IApiFilterwert) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.text = _data['text'];
      this.beschreibung = _data['beschreibung'];
      this.reihenfolge = _data['reihenfolge'];
    }
  }

  static fromJS(data: any): ApiFilterwert {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFilterwert();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['text'] = this.text;
    data['beschreibung'] = this.beschreibung;
    data['reihenfolge'] = this.reihenfolge;
    return data;
  }
}

/** Möglicher Wert eines Filters für Filter mit vorgegebenen Werten */
export interface IApiFilterwert {
  /** ID des Filterwerts */
  id: string;
  /** Text für die Anzeige/Auswahl */
  text: string;
  /** Zusätzlicher Beschreibungstext für den Filterwert. */
  beschreibung?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Filterwerte */
  reihenfolge: number;
}

/** Basis-Metadaten eines Dokuments */
export class ApiFiltergruppe implements IApiFiltergruppe {
  /** Eindeutige ID der Filtergruppe */
  id?: string | undefined;
  /** Name der Filtergruppe */
  name!: string;
  /** Code der Filtergruppe */
  code?: string | undefined;
  /** Beschreibung der Filtergruppe */
  beschreibung?: string | undefined;
  /** Nummerischer Wert zum Festlegen der Reihenfolge der Filtergruppen für den Benutzer in der Oberfläche */
  reihenfolge!: number;
  /** Verbelegung der Standortsuche */
  vorbelegungStandortsuche?: string | undefined;
  /** Art der Gliederung: 1: KFMAO, 2: Bauakte, 3: Gefma, 0: keine Angabe.
Dieser Wert kann nicht von außen gesetzt, sondern nur lesend genutzt werden. */
  gliederungstyp!: Gliederungstyp;
  /** Gibt an, ob die Filtergruppe mit anderen Benutzern geteilt werden kann */
  istTeilbar!: boolean;
  /** Gibt an, ob die Filtergruppe kopiert werden kann */
  istKopierbar!: boolean;

  constructor(data?: IApiFiltergruppe) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.code = _data['code'];
      this.beschreibung = _data['beschreibung'];
      this.reihenfolge = _data['reihenfolge'];
      this.vorbelegungStandortsuche = _data['vorbelegungStandortsuche'];
      this.gliederungstyp = _data['gliederungstyp'];
      this.istTeilbar = _data['istTeilbar'];
      this.istKopierbar = _data['istKopierbar'];
    }
  }

  static fromJS(data: any): ApiFiltergruppe {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFiltergruppe();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['code'] = this.code;
    data['beschreibung'] = this.beschreibung;
    data['reihenfolge'] = this.reihenfolge;
    data['vorbelegungStandortsuche'] = this.vorbelegungStandortsuche;
    data['gliederungstyp'] = this.gliederungstyp;
    data['istTeilbar'] = this.istTeilbar;
    data['istKopierbar'] = this.istKopierbar;
    return data;
  }
}

/** Basis-Metadaten eines Dokuments */
export interface IApiFiltergruppe {
  /** Eindeutige ID der Filtergruppe */
  id?: string | undefined;
  /** Name der Filtergruppe */
  name: string;
  /** Code der Filtergruppe */
  code?: string | undefined;
  /** Beschreibung der Filtergruppe */
  beschreibung?: string | undefined;
  /** Nummerischer Wert zum Festlegen der Reihenfolge der Filtergruppen für den Benutzer in der Oberfläche */
  reihenfolge: number;
  /** Verbelegung der Standortsuche */
  vorbelegungStandortsuche?: string | undefined;
  /** Art der Gliederung: 1: KFMAO, 2: Bauakte, 3: Gefma, 0: keine Angabe.
Dieser Wert kann nicht von außen gesetzt, sondern nur lesend genutzt werden. */
  gliederungstyp: Gliederungstyp;
  /** Gibt an, ob die Filtergruppe mit anderen Benutzern geteilt werden kann */
  istTeilbar: boolean;
  /** Gibt an, ob die Filtergruppe kopiert werden kann */
  istKopierbar: boolean;
}

/** Enthält alle Typen für die Gliederungselemente */
export enum Gliederungstyp {
  KeineAngabe = 0,
  Kfmao = 1,
  Bauakte = 2,
  Gefma = 3,
}

/** Eigenschaften eines Filters für die Auswahl in Filtergruppen */
export class ApiFiltergruppenfilter implements IApiFiltergruppenfilter {
  /** Eindeutige ID des Filter-Datensatzes für die externe Verwendung */
  id?: string | undefined;
  /** Name des Filters */
  name?: string | undefined;
  /** Beschreibung des Filters */
  beschreibung?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Filter */
  reihenfolge!: number;
  /** Gibt dem Nutzer die Möglichkeit bei zB Selects oder der Standortsuche einen komplexen Typ vorzubelegen */
  vorbelegteId?: string | undefined;
  /** Gibt dem Nutzer die Möglichkeit einen Filter Wert vorzubelegen */
  vorbelegterWert?: string | undefined;

  constructor(data?: IApiFiltergruppenfilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.beschreibung = _data['beschreibung'];
      this.reihenfolge = _data['reihenfolge'];
      this.vorbelegteId = _data['vorbelegteId'];
      this.vorbelegterWert = _data['vorbelegterWert'];
    }
  }

  static fromJS(data: any): ApiFiltergruppenfilter {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFiltergruppenfilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['beschreibung'] = this.beschreibung;
    data['reihenfolge'] = this.reihenfolge;
    data['vorbelegteId'] = this.vorbelegteId;
    data['vorbelegterWert'] = this.vorbelegterWert;
    return data;
  }
}

/** Eigenschaften eines Filters für die Auswahl in Filtergruppen */
export interface IApiFiltergruppenfilter {
  /** Eindeutige ID des Filter-Datensatzes für die externe Verwendung */
  id?: string | undefined;
  /** Name des Filters */
  name?: string | undefined;
  /** Beschreibung des Filters */
  beschreibung?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Filter */
  reihenfolge: number;
  /** Gibt dem Nutzer die Möglichkeit bei zB Selects oder der Standortsuche einen komplexen Typ vorzubelegen */
  vorbelegteId?: string | undefined;
  /** Gibt dem Nutzer die Möglichkeit einen Filter Wert vorzubelegen */
  vorbelegterWert?: string | undefined;
}

/** Dokumenteigenschaft, die einer Filtergruppe zugeordnet ist */
export class ApiFiltergruppendokumenteigenschaft implements IApiFiltergruppendokumenteigenschaft {
  /** Eindeutige ID des Dokumenteigenschaft-Datensatzes für die externe Verwendung */
  id?: string | undefined;
  /** Name der Eigenschaft */
  name?: string | undefined;
  /** Name der Eigenschaft am Dokument */
  propertyName?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Eigenschaften */
  reihenfolge!: number;

  constructor(data?: IApiFiltergruppendokumenteigenschaft) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.propertyName = _data['propertyName'];
      this.reihenfolge = _data['reihenfolge'];
    }
  }

  static fromJS(data: any): ApiFiltergruppendokumenteigenschaft {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFiltergruppendokumenteigenschaft();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['propertyName'] = this.propertyName;
    data['reihenfolge'] = this.reihenfolge;
    return data;
  }
}

/** Dokumenteigenschaft, die einer Filtergruppe zugeordnet ist */
export interface IApiFiltergruppendokumenteigenschaft {
  /** Eindeutige ID des Dokumenteigenschaft-Datensatzes für die externe Verwendung */
  id?: string | undefined;
  /** Name der Eigenschaft */
  name?: string | undefined;
  /** Name der Eigenschaft am Dokument */
  propertyName?: string | undefined;
  /** Der Index zur Festlegung der Reihenfolge der Eigenschaften */
  reihenfolge: number;
}

/** Enthält die konfigurierbaren "Werte" (Eigenschaften) eines ApiFiltergruppe-Objekts */
export class ApiFiltergruppenwerte implements IApiFiltergruppenwerte {
  /** ID des ApiFiltergruppe-Objekts, deren Werte enthalten sind */
  id!: string;
  /** Name der Filtergruppe */
  name!: string;
  /** Liste der im ApiFiltergruppe-Objekt verwendeten Werte */
  filter!: ApiFiltergruppenfilter[];
  /** Liste der im ApiFiltergruppe-Objekt verwendeten Dokumenteigenschaften */
  dokumenteigenschaften!: ApiFiltergruppendokumenteigenschaft[];

  constructor(data?: IApiFiltergruppenwerte) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.filter = [];
      this.dokumenteigenschaften = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      if (Array.isArray(_data['filter'])) {
        this.filter = [] as any;
        for (let item of _data['filter']) this.filter!.push(ApiFiltergruppenfilter.fromJS(item));
      }
      if (Array.isArray(_data['dokumenteigenschaften'])) {
        this.dokumenteigenschaften = [] as any;
        for (let item of _data['dokumenteigenschaften'])
          this.dokumenteigenschaften!.push(ApiFiltergruppendokumenteigenschaft.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApiFiltergruppenwerte {
    data = typeof data === 'object' ? data : {};
    let result = new ApiFiltergruppenwerte();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    if (Array.isArray(this.filter)) {
      data['filter'] = [];
      for (let item of this.filter) data['filter'].push(item.toJSON());
    }
    if (Array.isArray(this.dokumenteigenschaften)) {
      data['dokumenteigenschaften'] = [];
      for (let item of this.dokumenteigenschaften)
        data['dokumenteigenschaften'].push(item.toJSON());
    }
    return data;
  }
}

/** Enthält die konfigurierbaren "Werte" (Eigenschaften) eines ApiFiltergruppe-Objekts */
export interface IApiFiltergruppenwerte {
  /** ID des ApiFiltergruppe-Objekts, deren Werte enthalten sind */
  id: string;
  /** Name der Filtergruppe */
  name: string;
  /** Liste der im ApiFiltergruppe-Objekt verwendeten Werte */
  filter: ApiFiltergruppenfilter[];
  /** Liste der im ApiFiltergruppe-Objekt verwendeten Dokumenteigenschaften */
  dokumenteigenschaften: ApiFiltergruppendokumenteigenschaft[];
}

/** Api-Objekt für einen KfmaoCode */
export class ApiKfmaoCode implements IApiKfmaoCode {
  /** Code 1 */
  code1!: number;
  /** Code 2 */
  code2?: number | undefined;
  /** Code 3 */
  code3?: number | undefined;
  /** Code 4 */
  code4?: number | undefined;
  /** Beschreibung */
  beschreibung!: string;

  constructor(data?: IApiKfmaoCode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code1 = _data['code1'];
      this.code2 = _data['code2'];
      this.code3 = _data['code3'];
      this.code4 = _data['code4'];
      this.beschreibung = _data['beschreibung'];
    }
  }

  static fromJS(data: any): ApiKfmaoCode {
    data = typeof data === 'object' ? data : {};
    let result = new ApiKfmaoCode();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code1'] = this.code1;
    data['code2'] = this.code2;
    data['code3'] = this.code3;
    data['code4'] = this.code4;
    data['beschreibung'] = this.beschreibung;
    return data;
  }
}

/** Api-Objekt für einen KfmaoCode */
export interface IApiKfmaoCode {
  /** Code 1 */
  code1: number;
  /** Code 2 */
  code2?: number | undefined;
  /** Code 3 */
  code3?: number | undefined;
  /** Code 4 */
  code4?: number | undefined;
  /** Beschreibung */
  beschreibung: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
